import React, { useState, useEffect, useRef, useCallback } from "react";
import {
	Modal,
	Box,
	Typography,
	Card,
	CardContent,
	Button,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	TableContainer,
	Paper,
	TextField,
	MenuProps,
	Menu,
	styled,
	alpha,
	MenuItem,
	CircularProgress,
	Select,
	Tooltip,
	TooltipProps,
	tooltipClasses,
	Checkbox
} from "@mui/material";
// import Grid from "@mui/material/Grid2";
import Grid from "@mui/material/Grid2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useLocation } from "react-router-dom";
import Header from '../partials/header';
import LeftSidebar from '../partials/leftSidebar';
import sitesIcon from '../../assets/images/icon/sites.svg';
import sitesGreyIcon from '../../assets/images/icon/sites_grey.svg';
import eyeIcon from '../../assets/images/icon/eye.svg';
import threeDotsIcon from '../../assets/images/icon/threedots.png';
import licensesIcon from '../../assets/images/icon/licenses.svg';
import customersIcon from '../../assets/images/icon/customers.svg';
import siteOfflineIcon from '../../assets/images/icon/site_offline.svg';
import siteOnlineIcon from '../../assets/images/icon/site_online.svg';
import cameraOfflineIcon from '../../assets/images/icon/camera_offline.svg';
import cameraOnlineIcon from '../../assets/images/icon/camera_online.svg';
import cameraUnknownIcon from '../../assets/images/icon/camera_unknown.svg';
import refreshEdgeIcon from '../../assets/images/icon/refresh_edge.svg';
import updatingEdgeIcon from '../../assets/images/icon/updatingEdge.svg';
import homeIcon from '../../assets/images/icon/home.svg';
import { getMethod, postMethod, postMethodFormData } from "../../services/apiService";
import { clearStorageAndCookies } from "../../services/authService";
import { useNavigate } from 'react-router-dom';
import { FieldArray, Formik, Form, Field, ErrorMessage } from 'formik';
import { TextField as formikTextField } from 'formik-material-ui';
import { array, object, number, string, boolean, ValidationError, mixed } from 'yup';
import { Image, Form as RBFORM, Stack } from 'react-bootstrap';
import { getCountriesAPI, getStatesAPI, getCitiesAPI } from "../../services/placeService";
import UploadIn from '../../assets/images/icon/UploadIp.svg';
//import CloseIcon from '../../assets/images/icon/close-icon.svg';
import { maxHeaderSize } from "http";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import { ToastContext, useToastContext } from "../../context/toastContext";
import { putFormMethod } from "../../services/apiService";
import { AlertDialogs } from "../dialogs/alertDialogs";
import search from "../../assets/images/icon/search.svg"
import { getUserPriority } from "../../services/authService";
import DeleteIcon from '../../assets/images/delete.svg';
import { PROFILE_TYPE } from "../../helper/globalConstant";
import { usePartnerIdContext } from "../../context/partnerIdContext";
import debounce from "lodash.debounce";
import { debug } from "console";
import { Hidden } from "@material-ui/core";
import CheckIcon from '@mui/icons-material/Check';
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { allTimezones  } from "react-timezone-select";
import noteIcon from '../../assets/images/noteIcon.svg';

interface TempValues {
	adminname: string,
	adminemail: string,
	adminmobile: string,
	adminprofileimage: File | string | null;
	redirecturl: string,
}


const StyledMenu = styled((props: MenuProps) => (
	<Menu
		elevation={0}
		anchorOrigin={{
			vertical: 'bottom',
			horizontal: 'right',
		}}
		transformOrigin={{
			vertical: 'top',
			horizontal: 'right',
		}}
		{...props}
	/>
))(({ theme }) => ({
	'& .MuiPaper-root': {
		background: "#1F2F34 !important",
		padding: "5px 10px",
		borderRadius: 6,
		marginTop: theme.spacing(1),
		minWidth: 180,
		color: 'rgb(55, 65, 81)',
		boxShadow:
			'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
		'& .MuiMenu-list': {
			padding: '4px 0',
		},
		'& .MuiMenuItem-root': {
			padding: "5px 10px",
			'& .MuiSvgIcon-root': {
				fontSize: 18,
				color: theme.palette.text.secondary,
				marginRight: theme.spacing(1.5),
			},
			'&:active': {
				backgroundColor: "none",
			},
			'&:hover': {
				background: '#0B4A62',
				borderRadius: '10px'
			},
		},
		//   ...theme.applyStyles('dark', {
		// 	color: theme.palette.grey[300],
		//   }),
	},
}));
 
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#1D292E',
    fontSize: '12px',
    padding: '4px 12px',
    borderRadius: '5px',

  },
}));

const typographyStyle = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: 400,
  fontSize: '1rem',
  color: "#B4B7B8"
};


const CustomerOverview = () => {
	const abortControllerRef = useRef(new AbortController());
	const { setToast } = useToastContext() as ToastContext;
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const paraStyleHover = {
		padding: "5px 10px", '&:hover': {
			background: '#0B4A62',
			borderRadius: '10px'
		}
	}

	const navigate = useNavigate();
	const customerInputFile = useRef<HTMLInputElement | null>(null);
	const [editCustomerModalOpen, setEditCustomerModalOpen] = useState(false);
	const [customers, setCustomers] = useState<any>([]);
	const [filteredCustomers, setFilteredCustomers] = useState<any>([]);
	const [filteredSites, setFilteredSites] = useState<any>([]);
	const [customerLogoFile, setCustomerLogoFile] = useState<string | undefined>(undefined);
	const [siteDeviceOverview, setSiteDeviceOverview] = useState({ total: 0, active: 0, suspended: 0, pending: 0 });
	const [totalCustomerOverview, setTotalCustomerOverview] = useState({ total: 0, active: 0, suspended: 0 });
	const [totalLicenseOverview, setTotalLicenseOverview] = useState({ total: 0, active: 0, available: 0, expired: 0, expiring: 0, suspended: 0 });
	const [countryList, setCountryList] = useState([]);
	const [country, setCountry] = useState("");
	const [stateList, setStateList] = useState([]);
	const [filteredStateList, setFilteredStateList] = useState([]);
	const [state, setState] = useState("");
	const [cityList, setCityList] = useState([]);
	const [filteredCityList, setFilteredCityList] = useState([]);
	const [city, setCity] = useState("");
	const [customerTimeZone, setCustomerTimeZone] = useState("");
	//const [customerData, setCustomerData] = useState({ index: null, customer: [] })
	const [customerData, setCustomerData] = useState<{ index: number | null; customer: any }>({
		index: null,
		customer: {},
	});
	const [siteList, setSiteList] = useState<any>([]);
	const [customAction, setCustomAction] = useState(null);
	const [customerInitialValues, setCustomerInitialValues] = useState({
		enterpriseid: '',
		partnerid: '',
		name: '',
		email: '',
		addressline1: '',
		addressline2: '',
		postalcode: '',
		city: '',
		state: '',
		country: '',
		number: '',
		mobile: '',
		timezone: '',
	});
	const [customerUserId, setCustomerUserId] = useState("");
	const [customerUserName, setCustomerUserName] = useState("");
	const [customerEnterpriseId, setCustomerEnterpriseId] = useState("");
	const [customerEnterpriseIdForSite, setCustomerEnterpriseIdForSite] = useState("");
	const [customerEnterpriseSiteId, setCustomerEnterpriseSiteId] = useState("");
	const [addSiteModalOpen, setAddSiteModalOpen] = useState(false);
	const [checkRegistraionStatusModalOpen, setCheckRegistraionStatusModalOpen] = useState(false);
	const [getRegistraionStatusModalOpen, setGetRegistraionStatusModalOpen] = useState(false);
	const [suspendSiteAction, setSuspendSiteAction] = useState<string>("");
	const [suspendCustomerAction, setSuspendCustomerAction] = useState<string>("");
	const [searchText, setSearchText] = useState<string>("");
	const [userPriority, setUserPriority] = useState();
	const [customerAdminInitialValues, setCustomerAdminInitialValues] = useState<TempValues>({
		adminname: '',
		adminemail: '',
		adminmobile: '',
		adminprofileimage: null,
		redirecturl: '/auth/set-password?uk=',
	});
	const [customerAdminLogoFile, setCustomerAdminLogoFile] = useState<string | undefined>(undefined);
	const [siteLogData, setSiteLogData] = useState<any[]>([]);

	const [siteOrderId, setSiteOrderId] = useState<any[]>([]);
	const [isOpen, setIsOpen] = useState(false);
	const [copySiteList, setCopySiteList] = useState<any>([]);
	const { partnerId, setPartnerId } = usePartnerIdContext();
	const [ version, setVersion] = useState("");
	const [siteListPerCustomer, setSiteListPerCustomer] = useState<any>([]);
	const [updateStatus, setUpdateStatus] = useState("NotStarted");
	const [updatingSitesForAllCustomers, setUpdatingSitesForAllCustomers] = useState<any[]>([]);
	const [latestVersion,setLatestVersion] = useState("");
	const [checkedSitesForUpdate, setCheckedSitesForUpdate] = useState<any[]>([]); 
	const [checkedSitesNameForUpdate, setCheckedSitesNameForUpdate] = useState<any>("");
	const [selectAllForSitesUpdate, setSelectAllForSitesUpdate] = useState(false); 
	const [siteUpdatingInProgress, setSiteUpdatingInProgress] = useState<Record<number, boolean>>({});
	const requestIdRef = useRef(0);

	function getTimezoneOffset(zone: string) {
        const now = new Date();
        const formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: zone,
            hour12: false,
            hour: "2-digit",
            minute: "2-digit",
        });

        const parts = formatter.formatToParts(now);
        const localHour = Number(parts.find((p) => p.type === "hour")?.value);
        const localMinute = Number(parts.find((p) => p.type === "minute")?.value);

        const utcHour = now.getUTCHours();
        const utcMinute = now.getUTCMinutes();

        const totalMinutes = (localHour * 60 + localMinute) - (utcHour * 60 + utcMinute);
        return totalMinutes;
    }

    function formatOffset(minutes: number) {
        const sign = minutes >= 0 ? "+" : "-";
        const abs = Math.abs(minutes);
        const hours = String(Math.floor(abs / 60)).padStart(2, "0");
        const mins = String(abs % 60).padStart(2, "0");
        return `UTC${sign}${hours}:${mins}`;
    }

    const timezoneList = Object.keys(allTimezones).map((zone) => {
        const offsetInMinutes = getTimezoneOffset(zone);
        const formatted = formatOffset(offsetInMinutes);

        return {
            label: `(${formatted}) ${zone}`,
            value: zone,
        };
    });

	// useEffect(()=>{
	// 	console.log("siteUpdatingInProgress ", siteUpdatingInProgress )
	// 	console.log("updatingSitesForAllCustomers", updatingSitesForAllCustomers)
	// 	console.log("customAction", customAction)
	// 	console.log("customerData", customerData)
	// },[siteUpdatingInProgress, updatingSitesForAllCustomers, customAction, customerData ])

	useEffect(() => {
		setCustomers([]);
		setFilteredCustomers([]);
		fetchUserPriority();
	}, []);

	// useEffect(()=>{
	// 	console.log("checkedSitesForUpdate", checkedSitesForUpdate)
	// 	console.log("checkedSitesNameForUpdate", checkedSitesNameForUpdate)
	// },[checkedSitesForUpdate,checkedSitesNameForUpdate])


	const fetchUserPriority = async () => {
		const priority = await getUserPriority();
		setUserPriority(priority);
	}

	const fetchPartnerInfo = () => {
		let partnerInfo;
		const sess_user_data = localStorage.getItem("sess_user");
		if (sess_user_data != null) {
			try {
				const sess_user = JSON.parse(sess_user_data);
				const extractedProfileId = sess_user?.userProfile;
				if (extractedProfileId) {
					const priority = extractedProfileId?.priority;
					if (priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G1 || priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G2) {
						partnerInfo = extractedProfileId?.ownerId;
					} else if (priority == PROFILE_TYPE.SUPER_ADMIN || priority == PROFILE_TYPE.INTEGRATOR) {
						partnerInfo = partnerId
					}
				} else {
					console.error("Priority id not found in userProfile");
				}
			} catch (error) {
				console.error("Error parsing session user data:", error);
			}
		}
		return partnerInfo
	}

	const handleEditCustomerModalOpen = async (customer: any) => {
		let country_id = "";
		if (customer?.vEnterprise?.address?.country !== "") {
			country_id = await getCountryId(customer?.vEnterprise?.address?.country);
		}

		let state_id = "";
		if (customer?.vEnterprise?.address?.state !== "" && country_id != "") {
			state_id = await getStateId(customer?.vEnterprise?.address?.state, country_id.toString(), customer?.vEnterprise?.address?.city);
		}

		let city_id = "";
		if (customer?.vEnterprise?.address?.city !== "" && state_id != "") {
			city_id = await getCityId(customer?.vEnterprise?.address?.city, state_id.toString());
		}

		setCustomerInitialValues(prvData => ({
			...prvData,
			enterpriseid: customer?.vEnterprise?.enterpriseid,
			partnerid: customer?.vCentralUsers?.[0]?.userId,
			name: customer?.vEnterprise?.name,
			email: customer?.vEnterprise?.contact?.email?.[0]?.id,
			addressline1: customer?.vEnterprise?.address?.addressline1,
			addressline2: customer?.vEnterprise?.address?.addressline2,
			postalcode: customer?.vEnterprise?.address?.postalcode,
			city: city_id,
			state: state_id,
			country: country_id,
			number: customer?.vEnterprise?.contact?.phone?.number,
			mobile: customer?.vEnterprise?.contact?.mobile?.[0]?.number,
			timezone: customer?.vEnterprise?.timezone,
		}));
		setCustomerLogoFile(customer?.vEnterprise?.logourl);
		setCustomerUserId(customer?.vCentralUsers?.[0]?.userId);
		setCustomerUserName(customer?.vEnterprise?.name);

		setEditCustomerModalOpen(true);

	}

	const getCountryId = async (country_name: string) => {
		const country: any = countryList.find((country: any) => country.name === country_name);
		if (country !== undefined) {
			setCountry(country.name);
			return country.id;
		}
		else return "";
	}

	const getStateId = async (state_name: string, country_id: string, city_name: string) => {
		const f_statelist = stateList?.filter((item: any) => item.country_id === country_id);
		setFilteredStateList(f_statelist);
		const state: any = f_statelist.find((state: any) => state.name === state_name && state.country_id === country_id);
		if (state !== undefined) {
			setState(state.name);
			if (!city_name) {
				const f_citylist = cityList?.filter((item: any) => item.state_id === state.id);
				setFilteredCityList(f_citylist);
			}
			return state.id;
		}
		else return "";
	}

	const getCityId = async (city_name: string, state_id: string) => {
		const f_citylist = cityList?.filter((item: any) => item.state_id === state_id);
		setFilteredCityList(f_citylist);
		const city: any = f_citylist.find((city: any) => city.name === city_name && city.state_id === state_id);
		if (city !== undefined) {
			setCity(city.name);
			return city.id;
		}
		else return "";
	}


	const handleEditCustomerModalClose = () => setEditCustomerModalOpen(false);


	useEffect(() => {
		getCountryList();
		getStateList();
		getCityList();
	}, []);

	useEffect(() => {
		if (partnerId) {
			setCustomers([]);
			setFilteredCustomers([]);
			fetchSiteDeviceOverview();
			fetchTotalCustomerOverview();
			fetchTotalLicenseOverview();
			fetchCustomerList();
		}
	}, [partnerId])

	const fetchCustomerList = async () => {
		let partnerInfo = await fetchPartnerInfo()
		try{
			const resp = await getMethod(`customer/partner/${partnerInfo}`);
			if (resp?.status === 200) {
				const customer_list = resp?.data?.result;

				setCustomers(customer_list);
				setFilteredCustomers(customer_list);
				setMainLoader(false);
				updateSiteonlineOfflineStatus(customer_list);				
				// fetchEachCustomerUpdateStatus(customer_list);
			} else {
				setMainLoader(false);
			}
		} catch (error){
			console.log("API error in customer overview", error)
			setMainLoader(false);
		}
	}

	const updateSiteonlineOfflineStatus = async (customer_list: any) => {
		const updatedCustomers = await Promise.all(
			customer_list.map(async (item: any) => {
				const enterpriseId = item?.vEnterprise?.enterpriseid;

				if (enterpriseId) {
					const resp = await getMethod(`customer/site/enterpriseid/${enterpriseId}/status`);

					if (resp?.data?.code === 200) {
						return {
							...item,
							siteStatus: resp?.data?.result?.[0],
						};
					}
				}

				return item; // return original if no enterpriseId or error
			})
		);
		setCustomers(updatedCustomers);
		setFilteredCustomers(updatedCustomers);
		setMainLoader(false);
	}




	const fetchSiteDeviceOverview = async () => {
		let partnerInfo = await fetchPartnerInfo()
		try {
			const resp = await getMethod(`customer/overview/site/${partnerInfo}`);
			if (resp?.status === 200) {
				setSiteDeviceOverview(resp?.data?.result?.[0]);
			} else {
				setMainLoader(false);
			}
		} catch (error) {
			console.log("API error in site overview", error)
			setMainLoader(false);
		}
	}

	const fetchTotalCustomerOverview = async () => {
		if(!isSearching) setMainLoader(true)
		let partnerInfo = await fetchPartnerInfo()
		try {
			const resp = await getMethod(`customer/overview/${partnerInfo}`);
			if (resp?.status === 200) {
				setTotalCustomerOverview(resp?.data?.result?.[0]);
			} else {
				setMainLoader(false);
			}
		} catch (error) {
			console.log("API error in total customer overview", error)
			setMainLoader(false);
		}
	}

	const fetchTotalLicenseOverview = async () => {
		setMainLoader(true)
		let partnerInfo = await fetchPartnerInfo()
		try {
			const resp = await getMethod(`customer/overview/license/${partnerInfo}`);
			if (resp?.status === 200) {
				setTotalLicenseOverview(resp?.data?.result?.[0]);
			} else {
				setMainLoader(false);
			}
		} catch (error) {
			console.log("API error in license overview", error)
			setMainLoader(false);
		}
	}


	const getCountryList = async () => {
		const resp = await getCountriesAPI();
		setCountryList(resp.countries);
	}


	const getStateList = async () => {
		const resp = await getStatesAPI();
		setStateList(resp.states);
	}


	const getCityList = async () => {
		const resp = await getCitiesAPI();
		setCityList(resp.cities);
	}


	const handleCountryChange = async (e: any, setFieldValue: any) => {
		const selectedCountryId = e.target.value;
		const selectedCountry = countryList.find((country: any) => country.id.toString() === selectedCountryId) || { id: '', name: '', shortname: '' };
		setCountry(selectedCountry.id === '' || selectedCountry.id === '0' ? '' : selectedCountry.name);
		setFieldValue("country", selectedCountry.id.toString());

		if (selectedCountry.id === '' || selectedCountry.id === '0') {
			setState('');
			setCity('');
		}
		setTimeout(() => {
			const filteredStates = stateList.filter((state: any) => state.country_id.toString() === selectedCountry.id.toString());
			setFilteredStateList(filteredStates);
		}, 200);
	}


	const handleStateChange = async (e: any, setFieldValue: any) => {
		const selectedStateId = e.target.value;
		const selectedState = stateList.find((state: any) => state.id.toString() === selectedStateId) || { id: '', name: '', country_id: '' };
		setState(selectedState.id === '' || selectedState.id === '0' ? '' : selectedState.name);
		setFieldValue("state", selectedState.id.toString());

		if (selectedState.id === '' || selectedState.id === '0') {
			setCity('');
		}
		setTimeout(() => {
			const filteredCities = cityList.filter((city: any) => city.state_id.toString() === selectedState.id.toString());
			setFilteredCityList(filteredCities);
		}, 200);
	}


	const handleCityChange = async (e: any, setFieldValue: any) => {
		const selectedCityId = e.target.value;
		const selectedCity = cityList.find((country: any) => country.id.toString() === selectedCityId) || { id: '', name: '', state_id: '' };
		setCity(selectedCity.id === '' || selectedCity.id === '0' ? '' : selectedCity.name);
		setFieldValue("city", selectedCity.id.toString());
	}

	const handleTimeZoneChange = async (e: any, setFieldValue: any) => {
        setCustomerTimeZone(e.target.value);
        setFieldValue("timezone", e.target.value);
    }

	const handleInputFile = (type: string) => {
		if (type === "customer") {
			if (customerInputFile?.current) {
				customerInputFile!.current.click();
			}
		}
	}


	const previewImage = (e: React.ChangeEvent<HTMLInputElement>, type: string) => {
		if (e.target.files && e.target.files[0]) {
			const fileUrl = URL.createObjectURL(e.target.files[0]);
			if (type === "customerprofileimage") setCustomerLogoFile(fileUrl);
			else if (type === "adminprofileimage") setCustomerAdminLogoFile(fileUrl);
		}
	}


	const [phoneNumber, setPhoneNumber] = useState()
	const validatePhoneNumber = (phoneNumber: string) => {
		// This pattern allows an optional + followed by 10 to 15 digits, covering most international formats.
		const phonePattern = /^\+?\d{10,15}$/;

		if (!phonePattern.test(phoneNumber)) {
			//setPhoneNumber((prev) => ({ ...prev, number: phoneNumber, error: 'Invalid phone number!' }));
			//setErrors({ ...errors, mobile: "Invalid phone number" });
		} else {
			//setPhoneNumber((prev) => ({ ...prev, error: '', number: phoneNumber }));
			//setErrors({ ...errors, mobile: null });
		}
	};


	const handleNumber = (number: number, type: string) => {
		// setPhoneNumber(prev =>({...prev,number:`+${number}`}))
		if (type === "create") {
			//setFormData({ ...formData, 'mobile': number });
		} else {
			//setEditFormData({ ...editFormData, 'mobile': number });
		}
		validatePhoneNumber(number.toString());
	}



	const handleCustomAction = (id: any) => {
		customAction !== id ? setCustomAction(id) : setCustomAction(null)
	}

	const fetchCusomerSites = async (enterpriseId: any) => {
		await getMethod(`customer/site/enterpriseid/${enterpriseId}`, abortControllerRef.current?.signal as any).then((res) => {
			if (res?.status === 'canceled') {
				//Do nothing
			} else if (res?.data?.code === 200) {
				const data = res?.data?.result;
				const siteArray = data.map((item: any) => ({
					siteId: item?.vSite?.siteId,
					name: item?.vSite?.name,
				}));
				// setSiteListPerCustomer(siteArray);
				if(!isSearching) {
					hasFetchedVersions.current = false;
					setSiteList(res?.data?.result);
					setCopySiteList(res?.data?.result);
					showLoader(false);
				} else {
					setSearchResult((prev: any) => {
						return prev.map((item: any) => {
							const enterpriseId = item?.vCustomerResponse?.vEnterprise?.enterpriseid;

							const matchingSites = data.filter(
								(siteObj: any) =>
									siteObj.vSite?.enterpriseId === enterpriseId &&
									(
										siteObj.vSite?.name?.toLowerCase().includes(searchText) ||
										siteObj.vSite?.deviceid?.toLowerCase().includes(searchText)
									)
							);

							// console.log("matchingSites", matchingSites)

							// If matching sites found, update vCustomerSiteResponseList
							if (matchingSites.length > 0) {
								return {
									...item,
									vCustomerSiteResponseList: matchingSites
								};
							}

							return item; // no change
						});
					});					
				}
			} else {
				showLoader(false);
			}
		})


	}


	/* site update rollback */

	const [updateModalOpen, setUpdateModalOpen] = useState(false);
	const [rebootModalOpen, setRebootModalOpen] = useState(false);
	const [updateSiteAction, setUpdateSiteAction] = useState<string>("");
	const [selectedSiteForUpdate, setSelectedSiteForUpdate] = useState<any>();
	const [updateCustomerModalOpen, setUpdateCustomerModalOpen] = useState(false);
	const [updateEachSiteModalOpen, setUpdateEachSiteModalOpen] = useState(false);

	const hasFetchedVersions = useRef(false);
	const [loadingVersions, setLoadingVersions] = useState(true);

	// useEffect(()=>{
	// 	console.log("selectedSiteForUpdate", selectedSiteForUpdate)
	// 	console.log("siteList", siteList)
	// 	console.log("isOpen", isOpen)
	// 	console.log("intervalIdRef",intervalIdRef)
	// },[selectedSiteForUpdate, siteList, isOpen])


	// useEffect(() => {
	  
	// 	// if(userPriority === PROFILE_TYPE.SUPER_ADMIN){
	// 		const fetchVersions = async () => {
	// 			try {
	// 				setLoadingVersions(true);
	// 				const latestVersion = await getEdgeLatestVersion();

	// 				const promises = siteList.map(async (element: { vSite: { siteId: any } }) => {
	// 					const siteId = element?.vSite?.siteId;

	// 					const [currentVersion, previousVersion] = await Promise.all([
	// 						getEdgeCurrentVersion(siteId),
	// 						getEdgePreviousVersion(siteId),
	// 					]);

	// 					return {
	// 						...element,
	// 						latestVersion,
	// 						currentVersion,
	// 						previousVersion,
	// 					};
	// 				});

	// 				const updatedSites = await Promise.all(promises);
	// 				//console.log(updatedSites);
	// 				setSiteList(updatedSites);
	// 				hasFetchedVersions.current = true;
	// 				setLoadingVersions(false);
	// 			} catch (err) {
	// 				console.error("Version fetch failed", err);
	// 			}
	// 			finally {
	// 				setLoadingVersions(false);
	// 			}
	// 		};

	// 		if (siteList.length && !hasFetchedVersions.current) {
	// 			fetchVersions();
	// 		}

	// 	// }
	// 	// else {
	// 	// 	const fetchVersions = async () => {
	// 	// 		try {
	// 	// 			setLoadingVersions(true);
	// 	// 			const promises = siteList.map(async (element: { vSite: { siteId: any } }) => {
	// 	// 				const siteId = element?.vSite?.siteId;

	// 	// 				const [currentVersionForTable] = await Promise.all([
	// 	// 					getEdgeCurrentVersion(siteId),
	// 	// 					// getEdgePreviousVersion(siteId),
	// 	// 				]);

	// 	// 				return {
	// 	// 					...element,
	// 	// 					currentVersionForTable,
	// 	// 				};
	// 	// 			});

	// 	// 			const updatedSites = await Promise.all(promises);
	// 	// 			//console.log(updatedSites);
	// 	// 			setSiteList(updatedSites);
	// 	// 			hasFetchedVersions.current = true;
	// 	// 			setLoadingVersions(false);
	// 	// 		} catch (err) {
	// 	// 			console.error("Version fetch failed", err);
	// 	// 		}
	// 	// 	};

	// }, [siteList]);


	//To call version apis(current, latest, prev) for opened customer sites every 30secs
	const intervalIdRef = useRef<NodeJS.Timer | null>(null);
	const fetchVersions = async () => {
		const reqId = requestIdRef.current;
		try {
			setLoadingVersions(true);
			const latestVersion = await getEdgeLatestVersion();

			const promises = siteList.map(async (element: { vSite: { siteId: any } }) => {
				const siteId = element?.vSite?.siteId;

				const [currentVersion, previousVersion] = await Promise.all([
					getEdgeCurrentVersion(siteId),
					getEdgePreviousVersion(siteId),
				]);

				return {
					...element,
					latestVersion,
					currentVersion,
					previousVersion,
				};
			});

			const updatedSites = await Promise.all(promises);
			if (reqId !== requestIdRef.current) return;
			setSiteList(updatedSites);
			hasFetchedVersions.current = true;
			setLoadingVersions(false);
		} catch (err) {
			console.error("Version fetch failed", err);
		} finally {
			setLoadingVersions(false);
		}
	};

	useEffect(() => {
		if (siteList.length && isOpen) {
			if (!intervalIdRef.current) {
				fetchVersions();
				intervalIdRef.current = setInterval(() => {
					fetchVersions();
				}, 30000);
			}
		} else {
			if (intervalIdRef.current) {
				clearInterval(intervalIdRef.current);
				intervalIdRef.current = null;
			}
		}
	}, [siteList, isOpen]);


	useEffect(() => {
		
		let intervalId: number | undefined;

		const fetchEachCustomerUpdateStatusFunc = async () => {
			try {
				await fetchEachCustomerUpdateStatus(customers);
			} catch (err) {
				console.error("Error fetching customer update status:", err);
			}
		};
		fetchEachCustomerUpdateStatusFunc();
		intervalId = window.setInterval(fetchEachCustomerUpdateStatusFunc, 30000);
		return () => {
			if (intervalId) clearInterval(intervalId);
		};
	}, [customers]);

	
	useEffect(() => {
		
		let intervalId: number | undefined;

		const fetchCusomerSitesFunc = async () => {
			try {
				if(customerEnterpriseId)
					await fetchCusomerSites(customerEnterpriseId);
			} catch (err) {
				console.error("Error fetching customer sites data:", err);
			}
		};
		fetchCusomerSitesFunc();
		intervalId = window.setInterval(fetchCusomerSitesFunc, 30000);
		return () => {
			if (intervalId) clearInterval(intervalId);
		};
	}, [customerEnterpriseId]);



	const getEdgeCurrentVersion = async (siteId: any) => {
		try {

			// let endPoint = `/edge/version/site/${siteId}/current`;
			// if (siteId == 1) {
			// 	endPoint = `/edge/version/latest`;
			// } else {
			// 	endPoint = `/edge/version/site/${siteId}/current`;
			// }


			const endPoint = `/edge/version/site/${siteId}/current`;
			// const endPoint = `/edge/version/latest`;
			const response = await getMethod(endPoint);

			
			if (response?.data?.code === 200) {
				setSiteUpdatingInProgress(prev => ({ ...prev, [siteId]: false }));
				const version = response?.data?.result?.[0]?.version;
				setVersion(version);
				const timestamp = response?.data?.result?.[0]?.timestamp;
				return [version, timestamp];
			} else if (response?.data?.code === 401) {
				setSiteUpdatingInProgress(prev => ({ ...prev, [siteId]: false }));
				return [false, 0];
			} else if(response?.data?.status === 9575) {
				setSiteUpdatingInProgress(prev => ({ ...prev, [siteId]: true }));
			}
			else {
				setVersion("")
				setSiteUpdatingInProgress(prev => ({ ...prev, [siteId]: false }));
				return [false, 0];
			}
		} catch (error) {
			return [false, 0];
		}
	};

	const getEdgePreviousVersion = async (siteId: number) => {
		try {
			// let endPoint = "";
			// if (siteId == 1) {
			// 	endPoint = `/edge/version/latest`;
			// } else {
			// 	endPoint = `/edge/version/site/${siteId}/previous`;
			// }


			const endPoint = `/edge/version/site/${siteId}/previous`;
			const response = await getMethod(endPoint);

			if (response?.data?.code === 200) {
				const version = response?.data?.result?.[0]?.version;
				const timestamp = response?.data?.result?.[0]?.timestamp;
				return [version, timestamp];
			} else if (response?.data?.code === 401) {

				return [false, 0];
			} else {
				return [false, 0];
			}
		} catch (error) {
			return [false, 0];
		}
	};

	const getEdgeLatestVersion = async () => {
		try {
			const endPoint = `/edge/version/latest`;
			const response = await getMethod(endPoint);

			if (response?.data?.code === 200) {
				const version = response?.data?.result?.[0]?.version;
				const timestamp = response?.data?.result?.[0]?.timestamp;
				setLatestVersion(version);
				return [version, timestamp];
			} else if (response?.data?.code === 401) {

				return [false, 0];
			} else {
				return [false, 0];
			}
		} catch (error) {
			return [false, 0];
		}
	};

	useEffect(()=>{
		getEdgeLatestVersion();
	},[])

	function handleUpdate(siteElement: any): void {
		console.log("Function not implemented. " + siteElement?.currentVersion);
		setSelectedSiteForUpdate(siteElement)
		setUpdateSiteAction("Update")
		setUpdateModalOpen(true);

	}

	function handleRollback(siteElement: any): void {
		console.log("Function not implemented. " + siteElement?.currentVersion);
		setSelectedSiteForUpdate(siteElement)
		setUpdateSiteAction("Roleback")
		setUpdateModalOpen(true);
	}

	function handleReboot(siteElement: any): void {
		console.log("Function not implemented. " + siteElement?.currentVersion);
		setSelectedSiteForUpdate(siteElement)
		setRebootModalOpen(true)

	}

	function handleUpdateCustomer(customer: any): void {
		const enterpriseSites = updatingSitesForAllCustomers.find(
			(item) => item.enterpriseId === customer?.vEnterprise?.enterpriseid
		)?.siteData;

		const siteListArray = Array.isArray(enterpriseSites)
			? enterpriseSites.map((site: any) => ({
				siteId: site.siteId,
				siteName: site.siteName,
			}))
			: [{ siteId: enterpriseSites.siteId, siteName: enterpriseSites.siteName }];

		setSiteListPerCustomer(siteListArray);

		setSelectedSiteForUpdate(customer)
		setUpdateCustomerModalOpen(true);


	}


	// useEffect(()=>{
	// 	console.log("siteListPerCustomer", siteListPerCustomer)
	// },[siteListPerCustomer])

	const getUpdateResponse = async (action: string) => {
		const siteId = selectedSiteForUpdate?.vSite?.siteId;

		if (action === "Cancel") {
			setUpdateModalOpen(false);
			return;
		}

		if (!siteId) {
			setToast("Site ID not found", "error");
			return;
		}

		const version =
			action === "Update"
				? selectedSiteForUpdate?.latestVersion?.[0]
				: selectedSiteForUpdate?.previousVersion?.[0];

		if (!version) {
			setToast("Target version not found", "error");
			return;
		}

		const endPoint = `/edge/version/site/${siteId}/update/${version}`;
		//console.log("Endpoint:", endPoint);

		try {
			const resp = await getMethod(endPoint);

			if (resp?.status === 200) {
				setToast(resp?.data?.message, "success");
			} else {
				setToast(resp?.data?.message || "Something went wrong", "error");
			}
		} catch (error) {
			setToast("API call failed", "error");
			console.error(error);
		}
	};



	const getRebootResponse = async (action: string) => {

		const siteId = selectedSiteForUpdate?.vSite?.siteId;
		if (!siteId) {
			console.error("❌ Site ID not found");
			return;
		}


		if (action === "Cancel") {
			//console.log("Action cancelled.");
			return;
		} else if (action === "Reboot") {
			const endPoint = `/edge/version/site/${siteId}/reboot`;
			//console.log("Endpoint:", endPoint);
			try {
				const resp = await getMethod(endPoint);

				if (resp?.status === 200) {
					setToast(resp?.data?.message, "success");
				} else {
					setToast(resp?.data?.message || "Something went wrong", "error");
				}
			} catch (error) {
				setToast("API call failed", "error");
				console.error(error);
			}

		}


	}

	const getUpdateCustomerResponse = async (action: string) => {
		if (action === "Cancel") {
			return;
		}
		else if (action === "Update") {

			const payloadArray = Array.isArray(checkedSitesForUpdate)
			? checkedSitesForUpdate
			: [checkedSitesForUpdate];

			const payload = payloadArray.map((siteId) => ({
				requestVersion: latestVersion,
				siteId: siteId,
			}));

			// const payload = (Array.isArray(checkedSitesForUpdate) ? checkedSitesForUpdate : [checkedSitesForUpdate])
			// .map(siteId => ({
			// 	"requestVersion": latestVersion,
			// 	"siteId": siteId
			//   }));
			const endPoint = `edge/version/update`;
			// console.log("payload", payload)

			try {
				const resp = await postMethod(endPoint, payload);

				if (resp?.status === 200) {
					// console.log("payloadArray", payloadArray)
					// console.log("Site updated successfully");
					// getEdgeCurrentVersion(siteId);
					if (payloadArray.length === 1) {
						getEdgeCurrentVersion(payloadArray[0]);
					} 
					// else if (payloadArray.length > 1) {
					// 	payloadArray.forEach(siteId => {
					// 		getEdgeCurrentVersion(siteId);
					// 	});
					// }
					fetchEachCustomerUpdateStatus(customers);
					fetchCusomerSites(customerEnterpriseId);
				} else {
					setToast(resp?.data?.message || "Something went wrong", "error");
				}
			} catch (error) {
				setToast("API call failed", "error");
				console.error(error);
			}

		}
		else if (action === "Rollback") {
			const endPoint = `/edge/version/site/${checkedSitesForUpdate}/update/${selectedSiteForUpdate?.previousVersion?.[0]}`;
			try {
				const resp = await getMethod(endPoint);

				if (resp?.status === 200) {
					setToast(resp?.data?.message, "success");
					getEdgeCurrentVersion(checkedSitesForUpdate);
					fetchEachCustomerUpdateStatus(customers);
					fetchCusomerSites(customerEnterpriseId);
				} else {
					setToast(resp?.data?.message || "Something went wrong", "error");
				}
			} catch (error) {
				setToast("API call failed", "error");
				console.error(error);
			}
		}
	}

	const getUpdateEachSiteResponse = async (action: string) => {
		if (action === "Cancel") {
			return;
		}
		else if (action === "Update") {
			// setUpdateStatus("Continue");
			// setTimeout(() => {
			// 	setUpdateStatus("Completed");
			// }, 10000);
			const endPoint = `/edge/version/site/${siteId}/reboot`;

			try {
				const resp = await getMethod(endPoint);

				if (resp?.status === 200) {
					setToast(resp?.data?.message, "success");
				} else {
					setToast(resp?.data?.message || "Something went wrong", "error");
				}
			} catch (error) {
				setToast("API call failed", "error");
				console.error(error);
			}

		}
	}

	const handleCheckedSiteForUpdate = (siteId: number, checked: boolean) => {
		if (checked) {
			setCheckedSitesForUpdate(prev => [...prev, siteId]);
		} else {
			setCheckedSitesForUpdate(prev => prev.filter(id => id !== siteId));
		}
	};

	const handleSelectAllSitesForUpdate = (checked: boolean) => {
		setSelectAllForSitesUpdate(checked);
		if (checked) {
			const allIds = siteListPerCustomer?.map((site: { siteId: any; }) => site.siteId) || [];
			setCheckedSitesForUpdate(allIds);
		} else {
			setCheckedSitesForUpdate([]);
		}
	};

	useEffect(() => {
		if (siteListPerCustomer?.length > 0) {
			const allIds = siteListPerCustomer.map((site: any) => site.siteId);
			const allChecked = allIds.every((id: any) => checkedSitesForUpdate.includes(id));
			setSelectAllForSitesUpdate(allChecked);
		}
	}, [checkedSitesForUpdate, siteListPerCustomer]);


	const [loader, showLoader] = useState(false);
	const [mainLoader, setMainLoader] = useState(true);

	const handleCustomer = async (index: any, customer: any) => {
		
		requestIdRef.current += 1;  // invalidate old requests
		const isSameRow = customerData?.index === index;
		const data = customerData?.index === index ? { index: null, customer: [] } : { index, customer }
		//setCustomerList(customerData?.index === index ? [] : customerList)
		setCustomerData(data)
		setIsOpen(!isSameRow);

		if (!isSameRow && data?.customer?.vEnterprise?.enterpriseid) {
			if (abortControllerRef?.current) {
				abortControllerRef.current.abort();
				abortControllerRef.current = new AbortController();
				showLoader(true);
			}
			setCustomerEnterpriseId(data?.customer?.vEnterprise?.enterpriseid);
			setCustomerTimeZone(data?.customer?.vEnterprise?.timezone);
			await fetchCusomerSites(data?.customer?.vEnterprise?.enterpriseid);
			// await getEdgeCurrentVersion(data?.customer?.vEnterprise?.enterpriseid);
			//showLoader(false);
		}
	}



	/*************************** Add Site *************************************/
	const [siteEdit, setSiteEdit] = useState(false);
	const [siteId, setSiteId] = useState(false);
	const [siteInitialValues, setSiteInitialValues] = useState({
		enterpriseid: customerEnterpriseIdForSite,
		name: '',
		uniqueid: '',
		email: '',
		type: 'EDGE',
		addressline1: '',
		addressline2: '',
		postalcode: '',
		city: '',
		state: '',
		country: '',
		number: '',
		mobile: '',
		redirecturl: '/auth/set-password?uk=',
		status: '',
		ipList: [],
		dockerTagVersion: '',
		siteId: '',
		timezone: customerTimeZone,
	});


	useEffect(() => {
		setSiteInitialValues(prvdata => ({ ...prvdata, enterpriseid: customerEnterpriseIdForSite, timezone: customerTimeZone 
		}));
	}, [customerEnterpriseIdForSite])

	const handleAddSiteModalOpen = async (customer: any, action: string) => {
		if (action === "edit") {
			
			//setCustomerEnterpriseId(customer?.vSite?.enterpriseid);
			setSiteId(customer?.vSite?.siteId);
			setSiteEdit(true);
			let country_id = "";
			if (customer?.vSite?.address?.country !== "") {
				country_id = await getCountryId(customer?.vSite?.address?.country);
			} else {
				setFilteredStateList([]);
				setFilteredCityList([]);
			}

			let state_id = "";
			if (customer?.vSite?.address?.state !== "" && country_id != "") {
				state_id = await getStateId(customer?.vSite?.address?.state, country_id.toString(), customer?.vSite?.address?.city);
			} else {
				setFilteredStateList([]);
				setFilteredCityList([]);
			}

			let city_id = "";
			if (customer?.vSite?.address?.city !== "" && state_id != "") {
				city_id = await getCityId(customer?.vSite?.address?.city, state_id.toString());
			}
			setSiteInitialValues(prvData => ({
				...prvData,
				enterpriseid: customer?.vSite?.enterpriseId,
				partnerid: customer?.vCentralUsers?.[0]?.userId,
				name: customer?.vSite?.name,
				uniqueid: customer?.vSite?.deviceid,
				email: customer?.vSite?.contact?.email?.[0]?.id,
				type: customer?.vSite?.type,
				addressline1: customer?.vSite?.address?.addressline1,
				addressline2: customer?.vSite?.address?.addressline2,
				postalcode: customer?.vSite?.address?.postalcode,
				city: city_id,
				state: state_id,
				country: country_id,
				number: customer?.vEnterprise?.contact?.phone?.number || '',
				mobile: customer?.vEnterprise?.contact?.mobile?.[0]?.number || '',
				ipList: customer?.vSite?.ipList,
				dockerTagVersion: customer?.vSite?.dockerTagVersion,
				siteId: customer?.vSite?.siteId,
				timezone: customer?.vSite?.timezone,
			}));
		} else {
			//setCustomerEnterpriseId(customer?.vEnterprise?.enterpriseid);
			setSiteInitialValues({
				enterpriseid: customerEnterpriseIdForSite,
				name: "",
				uniqueid: "",
				email: "",
				type: 'EDGE',
				addressline1: "",
				addressline2: "",
				postalcode: "",
				city: "",
				state: "",
				country: "",
				number: "",
				mobile: "",
				redirecturl: '/auth/set-password?uk=',
				status: "",
				ipList: [],
				dockerTagVersion: '',
				siteId: "",
				timezone: customerTimeZone,
			});
			setSiteEdit(false);
			setFilteredStateList([]);
			setFilteredCityList([]);
		}

		setAddSiteModalOpen(true);
	}


	const handleAddSiteModalClose = () => {
		setCustomerEnterpriseId("");
		setCustomerTimeZone("");
		setAddSiteModalOpen(false);
	}

	// Added for Registration Status Check
	const handleCheckRegStatusModalOpen = async (customer: any) => {
		setSiteInitialValues((prvData) => ({
			...prvData,
			//deviceid: customer?.vSite?.deviceid,
			uniqueid: customer?.vSite?.deviceid,
			name: customer?.vSite?.name,
			status: customer?.vSite?.status,
			ipList: customer?.vSite?.ipList,
			dockerTagVersion: customer?.vSite?.dockerTagVersion,
			siteId: customer?.vSite?.siteId,
		}));
		setCheckRegistraionStatusModalOpen(true);
	};

	const handleUpdateEachSiteModalOpen = async (customer: any) => {
		setSiteInitialValues((prvData) => ({
			...prvData,
			//deviceid: customer?.vSite?.deviceid,
			uniqueid: customer?.vSite?.deviceid,
			name: customer?.vSite?.name,
			status: customer?.vSite?.status,
			ipList: customer?.vSite?.ipList,
			dockerTagVersion: customer?.vSite?.dockerTagVersion,
			siteId: customer?.vSite?.siteId,
		}));
		setUpdateEachSiteModalOpen(true);
	};


	const handleCheckRegStatusModalClose = () => {
		setCustomerEnterpriseId("");
		setCustomerTimeZone("");
		setCheckRegistraionStatusModalOpen(false);
	}

	const handleGetRegStatusModalOpen = async () => {
		handleRefreshSiteRegistrationStatus();
		setGetRegistraionStatusModalOpen(true);
	};

	const handleGetRegStatusModalClose = () => {
		setCustomerEnterpriseId("");
		setCustomerTimeZone("");
		setGetRegistraionStatusModalOpen(false);
		setCheckRegistraionStatusModalOpen(false);
	}

	const handleRefreshSiteRegistrationStatus = async function () {
		try {
			const endPoint = `site/log/search/${siteInitialValues.uniqueid}`;

			const response = await getMethod(endPoint);

			if (response?.data?.code === 200) {
				setSiteLogData(response.data.result);
			} else {
				setToast(response?.data?.message, "error");
			}
		} catch (error) {
			console.error("Error handling site log search:", error);
		}
	};


	const [suspendModalOpen, setSuspendModalOpen] = useState(false);
	const [deleteModalOpen, setDeleteModalOpen] = useState(false);
	const [suspendSiteModalOpen, setSuspendSiteModalOpen] = useState(false);
	const [deleteSiteModalOpen, setDeleteSiteModalOpen] = useState(false);

	const [isSearching, setIsSearching] = useState(false);
	const [searchResult, setSearchResult] = useState<any>([]);
	const prevSearchText = useRef("");
	const [initiateSearch, setInitiateSearch] = useState(true);
	const [updateForCustomerSite, setUpdateForCustomerSite] = useState(false);

	// useEffect(()=>{
	// 	console.log("searchResult", searchResult)
	// },[searchResult])


	const getConfirmResponse = async (action: string) => {
		// console.log("action", action)
		if (action === "cancel") {
			setSuspendModalOpen(false);
			setDeleteModalOpen(false);
		} else if (action === "Suspend" || action === "Delete" || action === "Activate") {
			let status = (action === "Suspend" ? "1" : (action === "Delete" ? "2" : "0"));
			const resp = await getMethod(`customer/${customerEnterpriseId}/status/${status}`);
			if (resp?.status === 200) {
				fetchTotalCustomerOverview();
				setToast(resp?.data?.message, "success");
				if(!isSearching) fetchCustomerList();
				else handleSearch(searchText);
			} else {
				setToast(resp?.data?.message, "error");
			}
		}
	}

	const handleSiteSuspendActivateDelete = useCallback(async (action: string) => {
		const actionId = {
			"Suspend": 4,
			"Delete": 5,
			"Activate": 1
		}
		if (action === "cancel") {
			setSuspendSiteModalOpen(false);
			setDeleteSiteModalOpen(false);
			setCustomerEnterpriseId("");
			setCustomerTimeZone("");
			setCustomerEnterpriseSiteId("");
		} else if (action === "Suspend" || action === "Delete" || action === "Activate") {
			try {
				const endPoint = `customer/site/${customerEnterpriseSiteId}/status/${actionId[action]}`;
				const response = await getMethod(endPoint);
				if (response?.status === 200) {
					await fetchCusomerSites(customerEnterpriseId);
					setSuspendSiteModalOpen(false);
					setDeleteSiteModalOpen(false);
					fetchSiteDeviceOverview();
					if(searchText) {
						updateSiteData(response?.data?.result?.[0]?.status);
					} else {
						setCustomerEnterpriseId("");
						setCustomerTimeZone("");
						setCustomerEnterpriseSiteId("");
					}
					setToast(response?.data?.message, "success");
				} else {
					setToast(response?.data?.message, "error");
				}
			} catch (error) {

			}
		}
	}, [setSuspendSiteModalOpen, setDeleteSiteModalOpen, setCustomerEnterpriseId, setToast, clearStorageAndCookies, navigate, customerEnterpriseId, customerEnterpriseSiteId, setCustomerEnterpriseSiteId, suspendSiteAction, fetchCustomerList])



	const updateSiteData = async (newStatus: string) => {

		var siteStatus = "";
		if (customerEnterpriseId) {
			const resp = await getMethod(`customer/site/enterpriseid/${customerEnterpriseId}/status`);					
			if (resp?.data?.code === 200) {
				siteStatus =  resp?.data?.result?.[0];
			}
		}

		setSearchResult((prevData: any) =>
			prevData.map((customer: any) => {
				const hasMatchingSite = customer.vCustomerSiteResponseList?.some(
					(site: any) => site?.vSite?.siteId === customerEnterpriseSiteId
				);

				return {
					...customer,
					// ✅ update customer-level siteStatus
					siteStatus: hasMatchingSite ? siteStatus : customer.siteStatus,
					vCustomerSiteResponseList: customer.vCustomerSiteResponseList?.map((site: any) => {
						if (site?.vSite?.siteId === customerEnterpriseSiteId) {
							return {
								...site,
								vSite: {
									...site.vSite,
									status: newStatus // ✅ update site-level status
								}
							};
						}
						return site;
					})
				};
			})
		);
		// setCustomerEnterpriseId("");
		setCustomerTimeZone("");
		setCustomerEnterpriseSiteId("");
	};

	const partner_id_new = useRef<string | null>(null);	

	useEffect(() => {
		partner_id_new.current = partnerId;
	}, [partnerId])

	
	const handleSearch = async (keywords: string) => {
		if (keywords === "") {
			setInitiateSearch(true);
			setIsSearching(false);
			setSearchResult([]);
			setSearchText("");
			prevSearchText.current = ""; // Reset previous
		} else if (keywords.length >= 3) {
			setIsSearching(true);			
			if (keywords !== prevSearchText.current) {
				showLoader(true);
				setSearchResult([]);
			}
			prevSearchText.current = keywords;
			setSearchText(keywords);
			
			const resp = await getMethod(`customer/partner/${partner_id_new.current}/search/${keywords}`);			
			if (resp?.data?.code === 200) {
				const data = resp?.data?.result;
				const sortedData = data.sort((a: any, b: any) =>
					b.vCustomerResponse.vEnterprise.enterpriseid - a.vCustomerResponse.vEnterprise.enterpriseid
				);

				sortedData.map((item: any, index: number) => {
					if(item?.vCustomerResponse?.vEnterprise?.name?.toLowerCase().includes(keywords.toLowerCase())) {
						sortedData[index].showSiteList = false;
					} else {
						sortedData[index].showSiteList = true;
					}
				});

				setSearchResult(sortedData);
				showLoader(false);
				updateSiteonlineOfflineStatusNew(sortedData);
				fetchCusomerSites(customerEnterpriseId);
			}
		}
	}

	const debouncedSearch = useCallback(debounce(handleSearch, 1000), []);

	const updateSiteonlineOfflineStatusNew = async (customer_list: any) => {		
		const updatedCustomers: any = await Promise.all(
			customer_list.map(async (item: any) => {				
				const enterpriseId = item?.vCustomerResponse?.vEnterprise?.enterpriseid;

				if (enterpriseId) {
					const resp = await getMethod(`customer/site/enterpriseid/${enterpriseId}/status`);					
					if (resp?.data?.code === 200) {
						return {
							...item,
							siteStatus: resp?.data?.result?.[0],
						};
					}
				}

				return item; // return original if no enterpriseId or error
			})
		);
		setSearchResult(updatedCustomers);
		setInitiateSearch(false);
		showLoader(false);
	}



	const updateShowSitelistStatus = (id: any) => {
		setSearchResult((prevResults: any[]) =>
			prevResults.map((item: any) =>
				item?.vCustomerResponse?.vEnterprise?.enterpriseid === id
					? { ...item, showSiteList: !item.showSiteList} 
					: item
			)
		);
	};


	useEffect(() => {
		if (!searchText || searchText === "") {
			setFilteredCustomers([...customers]);
			setSiteList([...copySiteList]);
		} /* else if(searchText !== "") {
			getSearchResults();
		} */
	}, [searchText, customers]);


	const getSearchResults = async () => {
		const resp = await getMethod(`customer/partner/${partnerId}/search/${searchText}`);
		if(resp?.code === 200) {
			setSearchResult(resp?.result);
		} 
	} 

	//To reset search on closing dropdown
	const prevIsOpen = useRef(isOpen);
	useEffect(() => {
		if (prevIsOpen.current && !isOpen) {
			setSearchText("");
		}
		prevIsOpen.current = isOpen;
	}, [isOpen]);

	const handleToggle = () => {
		setIsOpen(prev => !prev);
	};

	const handleNavigate = (customer: any, siteElement: any, index: any) => {
		var path = "";
		var siteId;
		if(!isSearching) {
			siteId = siteList[index]?.vSite?.siteId;
			localStorage.setItem('siteId', siteId)
			path = `/customer/view/${customer?.vEnterprise?.name}/${siteList[index]?.vSite?.name}/${customer?.vEnterprise?.enterpriseid}`
		} else {
			siteId = siteElement?.vSite?.siteId;
			const name = siteElement?.vSite?.name;
			localStorage.setItem('siteId', siteId)
			path = `/customer/view/${customer?.vCustomerResponse?.vEnterprise?.name}/${name}/${customer?.vCustomerResponse?.vEnterprise?.enterpriseid}`
		}
		// localStorage.setItem('siteId', data)
		navigate(path);
	}


	const [editCustomerAdminModalOpen, setEditCustomerAdminModalOpen] = useState(false);
	const [editCustomerAdminName, setEditCustomerAdminName] = useState("");
	const [editCustomerAdminEnterpriseId, setEditCustomerAdminEnterpriseId] = useState("");
	const [editCustomerAdminUserId, setEditCustomerAdminUserId] = useState("");
	const [customerAdminImageType, setCustomerAdminImageType] = useState("");

	const handleEditCustomerAdminModalOpen = async (customer: any) => {
		if (customer?.vCentralUsers?.[0]?.userId) {
			const resp = await getMethod(`central/user/${customer?.vCentralUsers?.[0]?.userId}`);
			if (resp?.data?.code === 200) {
				const firstName = resp?.data?.result?.[0]?.name?.trim() || "";
				const lastName = resp?.data?.result?.[0]?.lastName?.trim() || "";
				const fullName = (firstName + " " + lastName).trim();


				setCustomerAdminInitialValues(prvData => ({
					...prvData,
					adminname: (fullName),
					adminemail: resp?.data?.result?.[0]?.mailId ?? '',
					adminmobile: resp?.data?.result?.[0]?.mobile ?? '',
					adminprofileimage: resp?.data?.result?.[0]?.profilePicUrl ?? '',
				}));
				setCustomerAdminLogoFile(resp?.data?.result?.[0]?.profilePicUrl ?? '');
				setCustomerAdminImageType(resp?.data?.result?.[0]?.profilePicType ?? '');
				setEditCustomerAdminName(fullName);
				setEditCustomerAdminEnterpriseId(customer?.vEnterprise?.enterpriseid);
				setEditCustomerAdminUserId(resp?.data?.result?.[0]?.userId);
				setEditCustomerAdminModalOpen(true);
			}
		} else {
			setEditCustomerAdminEnterpriseId(customer?.vEnterprise?.enterpriseid);
			setEditCustomerAdminModalOpen(true);
		}
	}

	const handleEditCustomerAdminModalClose = () => setEditCustomerAdminModalOpen(false);

	const resendPasswordResetEmail = async (customer: any) => {
		const payload = {
			"userId": customer?.vCentralUsers?.[0]?.userId,
			"redirecturl": "/auth/set-password?uk=",
		}
		const resp = await postMethod(`customer/admin/resend/email/${customer?.vEnterprise?.enterpriseid}`, payload);

		if (resp?.status === 200) {
			setToast("Reset password email sent successfully!", "success");
		} else {
			setToast(resp?.data?.message, "error");
		}
	}


	const [adminProfileImageError, setAdminProfileImageError] = useState("");
	const [adminImageError, setAdminImageError] = useState("");
	const handleImageChange = (event: any, name: string, setFieldValue: any, setFieldTouched: any) => {
		const file = event.currentTarget.files[0];

		if (!file) {
			setAdminProfileImageError("Customer admin photo is required!");
			setCustomerAdminLogoFile(undefined);
			setFieldValue("adminprofileimage", "");
			return;
		}

		// Check file type
		const validTypes = ["image/jpeg", "image/png"];
		if (!validTypes.includes(file.type)) {
			setFieldValue("adminprofileimage", "");
			setAdminProfileImageError("Only JPG, and PNG image is allowed!");
			setCustomerAdminLogoFile(undefined);
			return;
		}

		// Check file size (should not exceed 5MB)
		const maxSize = 500 * 1024; // 500KB in bytes
		if (file.size > maxSize) {
			setAdminProfileImageError("Image size should not exceed 5MB!");
			setCustomerAdminLogoFile(undefined);
			setFieldValue("adminprofileimage", "");
			return;
		}

		setCustomerAdminLogoFile(file);
		setFieldValue("adminprofileimage", file);
		previewImage(event, "adminprofileimage");
		setFieldTouched("adminprofileimage", true, false);
		setAdminProfileImageError(""); // Clear error if image is valid

		// Reset the file input to allow re-uploading the same file
		event.target.value = "";
	};


	const removePhoto = async (name: string, setFieldValue: any) => {
		setCustomerAdminLogoFile(undefined);
		setFieldValue("adminprofileimage", "");
	}


	const convertBase64ToFormData = async (base64String: any, profilePicType: string) => {
		// Convert Base64 to a Blob
		const byteCharacters = atob(base64String.split(",")[1]); // Remove header
		const byteArrays = [];

		for (let i = 0; i < byteCharacters.length; i++) {
			byteArrays.push(byteCharacters.charCodeAt(i));
		}

		const byteArray = new Uint8Array(byteArrays);
		const blob = new Blob([byteArray], { type: profilePicType }); // Change type if needed

		var fileName = "";
		if (profilePicType === "image/jpeg" || profilePicType === "image/jpeg") {
			fileName = "image.jpg";
		} else if (profilePicType === "image/png") {
			fileName = "image.png";
		}

		// Convert Blob to File
		const file = new File([blob], fileName, { type: profilePicType });
		return file;
	};

	//Closed the dropdown when page scrolling
	useEffect(() => {
		const handleScroll = () => {
			setAnchorEl(null);
			setCustomAction(null);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	const getStatusColor = (status: any) => {
		switch (status) {
			case "REGISTERED":
				return "#07A25C";
			case "PENDING":
				return "#FB462E";
			case "SUSPENDED":
				return "#F9C817";
			default:
				return "gray";
		}
	};


	const toTitleCase = (str: any) => {
		return str?.toLowerCase().replace(/\b\w/g, (char: any) => char.toUpperCase());
	};


	const fetchLicenseTableData = async (getSiteID: any) => {
		const resp = await getMethod(`customer/order/siteid/details/${getSiteID}`);
		if (resp?.status === 200) {
			setSiteOrderId(resp?.data?.result[0]?.siteOrder?.orderId);

		} else {
			setToast(resp?.data?.message, "error");
		}
	};

	 
	//For getting each customer update status for any sites
	const fetchEachCustomerUpdateStatus = async (customer_list: any[]) => {
		try {
			const updatedCustomers = await Promise.all(
				customer_list.map(async (item: any) => {
					const enterpriseId = item?.vEnterprise?.enterpriseid;
					if (!enterpriseId) return null; 

					const resp = await getMethod(`edge/version/enterpriseid/${enterpriseId}/status`);

					if (resp?.data?.code === 200) {
						return {
							enterpriseId,
							siteData: resp.data.result || null, // store site data
						};
					} 
					else {
						// setToast(resp?.data?.message || "Error fetching status", "error");
						return {
							enterpriseId,
							siteData: null,
						};
					}
				})
			);
			setUpdatingSitesForAllCustomers(updatedCustomers);
		} catch (error) {
			console.error("Error fetching customer update statuses:", error);
			setToast("Something went wrong while fetching site statuses", "error");
		}
	};


	const handleClickAway = () => {
		setCustomAction(null);
	};


	const clickedOnEnterpriseRow = (index: number, customer: any) => {
		showLoader(true); 
		setCustomerData({ index: null, customer: [] }); 
		setSiteList([]); 
		handleCustomer(index, customer);
	}


	return (
		<>
			<Box sx={{ display: 'flex' }} onClick={() => { setCustomAction(null) }}>
				<Header title="Customer Overview" />
				<LeftSidebar />

				{/* Main Content */}
				<Box
					component="main"
					sx={{
						flexGrow: 1,
						p: 3,
						marginTop: 8,
						padding: '0',
					}}
				>
					<Box p={3} sx={{ backgroundColor: "#03171F", color: "#ffffff", minHeight: "100vh" }}>
						{/* Summary Section */}
						<Grid container spacing={2} mb={2}>
							<Card
								sx={{
									backgroundColor: "#1D292E",
									width: '100%',
									display: "flex",
								}}>
								<CardContent
									sx={{
										backgroundColor: "##1D292E",
										width: '25%',
									}}
									className="headercardContent"
								>
									<Box
										sx={{
											display: "flex",
											border: '0',
											borderStyle: 'solid',
											borderBottomWidth: '1px ',
											borderColor: '#5A5F60',
											justifyContent: 'space-between',
											alignItems: 'center',
											paddingBottom: '7px',
											marginBottom: '7px',
										}}
									>
										<Typography variant="h6"
											sx={{
												color: '#E2E3E3',
												fontSize: '16px',
												fontWeight: '500',
												margin: '0',
												padding: '0',
												display: 'flex',
												alignItems: 'center',
												gridGap: '8px',
											}}
										>	 <img src={customersIcon} alt="" width={20} height={20} /> Total Customers
										</Typography>
										<Typography variant="h4" sx={{
											color: '#E2E3E3',
											width: '33px',
											height: '33px',
											borderRadius: '50%',
											fontSize: '14px',
											fontWeight: '500',
											alignItems: 'center',
											justifyContent: 'center',
											background: '#293236',
											display: 'flex',
										}}>{totalCustomerOverview.total}</Typography>
									</Box>
									<Box
										sx={{
											display: "flex",
										}}
									>
										<Typography variant="body2" sx={{ color: '#B4B7B8', fontSize: '13px', }}>
											<span className="green"></span> Active : {totalCustomerOverview.active} | <span className="yellow"></span> Suspended : {totalCustomerOverview.suspended}
										</Typography>
									</Box>
								</CardContent>
								<CardContent
									sx={{
										backgroundColor: "##1D292E",
										width: '25%',
									}}
									className="headercardContent"
								>
									<Box
										sx={{
											display: "flex",
											border: '0',
											borderStyle: 'solid',
											borderBottomWidth: '1px ',
											borderColor: '#5A5F60',
											justifyContent: 'space-between',
											alignItems: 'center',
											paddingBottom: '7px',
											marginBottom: '7px',
										}}
									>
										<Typography variant="h6"
											sx={{
												color: '#E2E3E3',
												fontSize: '16px',
												fontWeight: '500',
												display: 'flex',
												alignItems: 'center',
												gridGap: '8px',
											}}
										>
											<img src={sitesIcon} alt="" width={20} height={20} />
											Sites / Devices
										</Typography>
										<Typography variant="h4" sx={{
											color: '#E2E3E3',
											width: '33px',
											height: '33px',
											borderRadius: '50%',
											fontSize: '14px',
											fontWeight: '500',
											alignItems: 'center',
											justifyContent: 'center',
											background: '#293236',
											display: 'flex',
										}}>{siteDeviceOverview.total}</Typography>
									</Box>
									<Box sx={{ display: "flex" }}>
										<Typography variant="body2" sx={{ color: '#B4B7B8', fontSize: '13px', }}>
											<span className="green"></span> Registered : {siteDeviceOverview.active} |  <span className="yellow"></span>Suspended : {siteDeviceOverview.suspended} | <span className="red"></span>Unregistered : {siteDeviceOverview.pending}
										</Typography>
									</Box>
								</CardContent>
								<CardContent
									sx={{
										backgroundColor: "##1D292E",
										width: '50%',
									}}
								>
									<Box
										sx={{
											display: "flex",
											border: '0',
											borderStyle: 'solid',
											borderBottomWidth: '1px ',
											borderColor: '#5A5F60',
											justifyContent: 'space-between',
											alignItems: 'center',
											paddingBottom: '7px',
											marginBottom: '7px',
										}}
									>
										<Typography variant="h6"
											sx={{
												color: '#E2E3E3',
												fontSize: '16px',
												fontWeight: '500',
												display: 'flex',
												alignItems: 'center',
												gridGap: '8px',
											}}
										>	 <img src={licensesIcon} alt="" width={20} height={20} /> Total Licenses
										</Typography>
										<Typography variant="h4" sx={{
											color: '#E2E3E3',
											width: '33px',
											height: '33px',
											borderRadius: '50%',
											fontSize: '14px',
											fontWeight: '500',
											alignItems: 'center',
											justifyContent: 'center',
											background: '#293236',
											display: 'flex',
										}}>{totalLicenseOverview.total}</Typography>
									</Box>
									<Box
										sx={{
											display: "flex",
										}}
									>
										<Typography variant="body2" sx={{ color: '#B4B7B8', fontSize: '13px', }}>
											<span className="green"></span> Active : {totalLicenseOverview.active} | <span className="green"></span> Available : {totalLicenseOverview.available} | <span className="red"></span> Expiring : {totalLicenseOverview.expiring} | <span className="red"></span> Expired : {totalLicenseOverview.expired} | <span className="yellow"></span> Suspended : {totalLicenseOverview.suspended}
										</Typography>
									</Box>
								</CardContent>

							</Card>
						</Grid>

						<Grid container spacing={2} mb={5} mt={5}>
							<Grid size={{ xs: 12, md: 6 }}>
								<div
									style={{
										height: 41,
										padding: 12,
										borderRadius: 30,
										border: "1px solid #5a5f60",
										display: "flex",
										alignItems: "center",
										justifyContent: "space-between",
										background: "#1F2F34",
										width: "100%",
									}}
								>
									<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
										<img
											src={search}
											style={{ cursor: "pointer" }}
										/>
										<input
											onChange={(e) => { setSearchText(e.target.value); debouncedSearch(e.target.value); }}
											placeholder={"Search by customer name or site name or UUID"}
											style={{
												background: "#1F2F34",
												border: "none",
												padding: 0,
												margin: 0,
												marginLeft: 8,
												color: "#FFF",
												width: "100%",
											}}
										/>
									</div>
								</div>
							</Grid>
							{userPriority !== PROFILE_TYPE.SUPER_ADMIN && <Grid size={{ xs: 12, md: 6 }}>
								<Button
									variant="contained"
									sx={{
										backgroundColor: "#17B2EB",
										color: "#1F2F34",
										marginLeft: 2,
										textTransform: "none",
										borderRadius: '30px !important',
										fontSize: '14px',
										fontWeight: 'normal',
										"&:hover": { backgroundColor: "#fff" },
										float: 'right',
									}}
								>
									<Link
										to="/customer/new"
										style={{ textDecoration: 'none', color: 'black' }}
									>+ Register Customer </Link>
								</Button>
							</Grid>
							}
						</Grid>

						<TableContainer
							component={Paper}
							sx={{
								overflowX: 'auto',
								overflowY: 'hidden',
								width: '100%',
								maxHeight: '100%',
							}}
						>
							<Table sx={{ backgroundColor: "#03171f", border: '1px solid #313838' }}>
								<TableHead>
									<TableRow style={{ borderBottom: "2px solid #313838" }}>
										<TableCell style={{ color: '#E2E3E3', borderColor: '#313838' }}>No.</TableCell>
										<TableCell style={{ color: '#E2E3E3', borderColor: '#313838' }}>&nbsp;</TableCell>
										<TableCell style={{ color: '#E2E3E3', borderColor: '#313838' }}>Customers</TableCell>
										<TableCell style={{ color: '#E2E3E3', borderColor: '#313838', textAlign: 'center' }}>Logo</TableCell>
										{/* <TableCell style={{ color: '#E2E3E3', borderColor: '#313838' }}>Address</TableCell> */}
										<TableCell style={{ color: '#E2E3E3', borderColor: '#313838' }}>Contact</TableCell>
										<TableCell style={{ color: '#E2E3E3', borderColor: '#313838' }}>Person of Contact</TableCell>
										<TableCell style={{ color: '#E2E3E3', borderColor: '#313838' }}>Version</TableCell>
										<TableCell style={{ color: '#E2E3E3', borderColor: '#313838' }}>Licenses</TableCell>
										<TableCell style={{ color: '#E2E3E3', borderColor: '#313838' }}>&nbsp;</TableCell>
									</TableRow>
								</TableHead>


								<TableBody>
									{mainLoader ? (
										<TableRow sx={{ padding: 0, margin: 0, borderBottom: "1px solid #313838", cursor: "pointer" }}>
											<TableCell colSpan={8} sx={{ color: '#E2E3E3', borderColor: '#313838', textAlign: "center" }}>
												<CircularProgress color="primary" />
											</TableCell>
										</TableRow>
									) : !isSearching ? (
										filteredCustomers?.length > 0 ? (
											filteredCustomers.map((customer: any, index: number) => (
												<>
													<TableRow sx={{ padding: '0', margin: '0', borderBottom: "1px solid #313838", cursor: "pointer" }} key={index}>
														<TableCell onClick={() => { }} sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0', verticalAlign: 'sub' }}>{index + 1}</TableCell>

														<TableCell onClick={() => {clickedOnEnterpriseRow(index, customer);}} sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0', verticalAlign: 'sub' }}>
															<HtmlTooltip
																//Uncomment this-
																title={
																	<Box sx={{ backgroundColor: '#1D292E', p: 1 }}>
																		{/* {groupData.map((data: any, idx: number) => ( */}
																		<Box sx={{ pb: '12px', backgroundColor: '#1D292E' }}>
																			{/* <Typography sx={{ pb: '4px', fontSize: '12px' }}>{data.groupName}</Typography> */}
																			<Typography
																				color="#A5A8A9"
																				fontSize="14px"
																				display="flex"
																				alignItems="center"
																				flexDirection="row"
																				gap="8px"
																			>
																				<img src={siteOnlineIcon} alt="site online" /> {customer?.siteStatus?.numberOfOnlineSite}
																				<img src={siteOfflineIcon} alt="site offline" /> {customer?.siteStatus?.numberOfOfflineSite}
																			</Typography>

																			{/* Second line: Camera icons */}
																			<Typography
																				color="#A5A8A9"
																				fontSize="14px"
																				display="flex"
																				alignItems="center"
																				flexDirection="row"
																				gap="8px"
																				mt={1} // small top margin for spacing
																			>
																				<img src={cameraOnlineIcon} alt="camera online" /> {customer?.siteStatus?.numberOfOnlineChannel}
																				<img src={cameraOfflineIcon} alt="camera offline" /> {customer?.siteStatus?.numberOfOfflineChannel}
																				<img src={cameraUnknownIcon} alt="camera unknown" /> {customer?.siteStatus?.numberOfUnknownChannel}
																			</Typography>
																		</Box>
																		{/* ))} */}
																	</Box>
																}
																
																placement="right"
																slotProps={{
																	popper: {
																		modifiers: [
																			{
																				name: 'offset',
																				options: { offset: [8, 0] },
																			},
																		],
																	},
																}}
															>
															{customer?.siteStatus && <div className="pStatusBG">
																<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
																{(customer?.siteStatus?.connectivityStatus === undefined || customer?.siteStatus?.connectivityStatus === 1 || customer?.siteStatus?.connectivityStatus === 3
																// || customer?.siteStatus?.pending === true
																 ) && 
																// <div className="statusBG" style={{ borderLeft: "2px solid red" }}><span className="red"></span></div>
																<img src={siteOfflineIcon} alt="" width={16} height={16} />
																}
																{(customer?.siteStatus?.connectivityStatus === 0) && 
																	<img src={siteOnlineIcon} alt="" width={16} height={16} />
																}
																{(customer?.siteStatus?.cameraConnectivityStatus === undefined || customer?.siteStatus?.cameraConnectivityStatus === 1) && 
																<img src={cameraOfflineIcon} alt="" width={16} height={16} />
																}
																{(customer?.siteStatus?.cameraConnectivityStatus === 0) && 
																<img src={cameraOnlineIcon} alt="" width={16} height={16} />
																}
																{(customer?.siteStatus?.cameraConnectivityStatus === 3) && 
																<img src={cameraUnknownIcon} alt="" width={16} height={16} />
																}
																</Box>
																{/* {(customer?.siteStatus?.suspended === true) && <div className="statusBG" style={{ borderLeft: "2px solid yellow" }}><span className="yellow"></span></div>} */}
															</div>}
															</HtmlTooltip>
														</TableCell>

														<TableCell onClick={() => {clickedOnEnterpriseRow(index, customer);}} sx={{ borderColor: '#313838', margin: '0', display: 'flex', width: '250px' }}>
															<ExpandMoreIcon sx={{ cursor: 'pointer', color: '#B4B7B8', fontSize: '24px', display: 'inline-block', transform: customerData?.index === index ? 'rotate(180deg)' : 'rotate(0deg)', transition: '0.5s' }} />

															{customer?.vEnterprise?.status === 0 && <span className="green" style={{ padding: "4px", marginTop: "7px" }}></span>}
															{customer?.vEnterprise?.status === 1 && <span className="yellow" style={{ padding: "4px", marginTop: "7px" }}></span>}

															<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0'}}>
																{customer?.vEnterprise?.name}
															</Typography>
														</TableCell>

														<TableCell onClick={() => {clickedOnEnterpriseRow(index, customer);}} sx={{ padding: '0', borderColor: '#313838', margin: '0', textAlign: 'center', width: '250px' }}>
															<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', }}><Image src={customer?.vEnterprise?.logourl} width="50" /></Typography>
														</TableCell>

														{/* <TableCell onClick={() => {clickedOnEnterpriseRow(index, customer);}} sx={{ padding: '0', borderColor: '#313838', margin: '0', maxWidth: "250px" }}>
															<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', paddingLeft: '20px', margin: '0', width: '250px', }}>
																{[customer?.vEnterprise?.address?.addressline1, 
																customer?.vEnterprise?.address?.addressline2,
																customer?.vEnterprise?.address?.city,
																customer?.vEnterprise?.address?.state,
																customer?.vEnterprise?.address?.postalcode,
																customer?.vEnterprise?.address?.country]
																	.filter(Boolean) // Filters out undefined, null, or empty values
																	.join(", ")}
															</Typography>
														</TableCell> */}

														<TableCell onClick={() => {clickedOnEnterpriseRow(index, customer);}}>
															<Typography sx={{ color: '#B4B7B8', fontSize: '14px', margin: '0', width: '10%', }}>
																{customer?.vEnterprise?.contact?.mobile?.[0]?.number}
																{customer?.vEnterprise?.contact?.mobile?.[0]?.number && customer?.vEnterprise?.contact?.email?.[0]?.id ? <br /> : ''}
																{customer?.vEnterprise?.contact?.email?.[0]?.id}
															</Typography>
														</TableCell>

														<TableCell onClick={() => {clickedOnEnterpriseRow(index, customer);}}>
															<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>{`${customer?.vCentralUsers?.[0]?.name || ""} ${customer?.vCentralUsers?.[0]?.lastName || ""}`}</Typography>
														</TableCell>

														<TableCell onClick={() => {clickedOnEnterpriseRow(index, customer);}} sx={{ padding: '0', borderColor: '#313838', margin: '0', textAlign: 'center', width: '150px' }}>
															<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', }}>{customer?.currentVersion?.[0]}</Typography>
														</TableCell>

														<TableCell onClick={() => {clickedOnEnterpriseRow(index, customer);}} sx={{ width: '10%' }}>
															<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>
																<Box sx={{ display: 'flex', gridGap: '10px', justifyContent: "space-evenly" }}>
																	<Typography sx={{ color: "#B4B7B8", fontSize: '14px', textAlign: "center" }}> <span className="green"></span><br/>{customer?.licenseCount?.active ?? 0}</Typography>
																	<Typography sx={{ color: "#B4B7B8", fontSize: '14px', textAlign: "center" }}><span className="yellow"></span><br/>{customer?.licenseCount?.suspended ?? 0}</Typography>
																	<Typography sx={{ color: "#B4B7B8", fontSize: '14px', textAlign: "center" }}><span className="red"></span><br/>{customer?.licenseCount?.expired ?? 0}</Typography>
																</Box>
															</Typography>
														</TableCell>

														<TableCell sx={{ position: 'relative' }}>
															<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', padding: '0', margin: '0', }}>
																<Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', position: 'relative' }}>
																	{updatingSitesForAllCustomers.find(
																		(item: any) =>
																			item.enterpriseId === customer?.vEnterprise?.enterpriseid &&
																			item.siteData?.length > 0
																	) ? (
																		<Image
																			src={refreshEdgeIcon}
																			alt="Refresh"
																			style={{ cursor: 'pointer', width: 20, height: 20 }}
																			onClick={(e) => {
																				// console.log("customer chekcing", customer)
																				e.stopPropagation();
																				// const allSiteIds = customer?.vEnterprise?.sites || [];
																				// setCheckedSitesForUpdate(allSiteIds);
																				const matchedEnterprise = updatingSitesForAllCustomers.find(
																					(item: any) =>
																						item.enterpriseId === customer?.vEnterprise?.enterpriseid
																				);

																				if (matchedEnterprise?.siteData?.length > 0) {
																					const siteIds = matchedEnterprise.siteData.map((site: any) => site.siteId);
																					setCheckedSitesForUpdate(siteIds);
																				} else {
																					setCheckedSitesForUpdate([]);
																				}
				
																				handleUpdateCustomer(customer);
																				setSelectAllForSitesUpdate(true);
																			}}
																		/>
																	) : (
																		<Box sx={{ width: 20, height: 20 }} />
																	)}
																	<Link to={`/customer/details/${customer?.vEnterprise?.name}/${customer?.vEnterprise?.enterpriseid}`} style={{ cursor: "pointer !important", display: "flex" }}>
																		{customer?.vEnterprise?.status === 0 ? (
																			<Image src={eyeIcon} style={{ cursor: "pointer", width: 16, height: 16 }} />
																		) : (
																			<Image src={eyeIcon} style={{ cursor: "not-allowed", opacity: 0.5 }} />
																		)}

																	</Link>

																	<Image src={threeDotsIcon}
																		onClick={(e) => {
																			e.stopPropagation();
																			setCustomerEnterpriseIdForSite(customer?.vEnterprise?.enterpriseid)
																			// setCustomerEnterpriseId(customer?.vEnterprise?.enterpriseid);
																			handleCustomAction(index);
																			handleClick(e);
																			setCustomerTimeZone(customer?.vEnterprise?.timezone);
																		}}
																		style={{ cursor: "pointer" }}
																	/>
																	<ClickAwayListener onClickAway={handleClickAway}>
																		<StyledMenu
																			id="demo-customized-menu"
																			MenuListProps={{
																				'aria-labelledby': 'demo-customized-button',
																			}}
																			anchorEl={anchorEl}
																			open={customAction === index}
																			onClose={undefined}
																			//onClick={(event) => event.stopPropagation()}
																		>
																			<MenuItem onClick={(e) => { e.stopPropagation(); handleEditCustomerModalOpen(customer); setCustomAction(null); }} disableRipple>
																				Edit Customer
																			</MenuItem>
																			{customer?.vCentralUsers?.length > 0 && (<MenuItem onClick={(e) => { e.stopPropagation(); handleEditCustomerAdminModalOpen(customer); setCustomAction(null); }} disableRipple>
																				Edit Customer Admin
																			</MenuItem>
																			)}
																			<MenuItem onClick={(e) => { e.stopPropagation(); handleAddSiteModalOpen(customer, "new"); setCustomAction(null); }} disableRipple>
																				Add New Site / Device
																			</MenuItem>
																			<MenuItem onClick={(e) => { setSuspendModalOpen(customer); setCustomerEnterpriseId(customer?.vEnterprise?.enterpriseid); setCustomAction(null); setSuspendCustomerAction(customer?.vEnterprise?.status === 0 ? "Suspend" : "Activate"); }} disableRipple>
																				{customer?.vEnterprise?.status === 0 ? "Suspend Customer" : "Activate Customer"}
																			</MenuItem>
																			{customer?.vCentralUsers?.length > 0 && (<MenuItem onClick={(e) => { e.stopPropagation(); resendPasswordResetEmail(customer); setCustomAction(null); }} disableRipple>
																				Resend Password Reset Email
																			</MenuItem>
																			)}
																			<MenuItem onClick={(e) => { setDeleteModalOpen(customer); setCustomerEnterpriseId(customer?.vEnterprise?.enterpriseid); setCustomAction(null); }} disableRipple>
																				Delete Customer
																			</MenuItem>
																			{updatingSitesForAllCustomers.find(
																				(item: any) =>
																					item.enterpriseId === customer?.vEnterprise?.enterpriseid &&
																					item.siteData?.length > 0
																			) && (
																				<MenuItem onClick={(e) => {
																					// const allSiteIds = customer?.vEnterprise?.sites || [];
																					// setCheckedSitesForUpdate(allSiteIds);
																					const matchedEnterprise = updatingSitesForAllCustomers.find(
																						(item: any) =>
																							item.enterpriseId === customer?.vEnterprise?.enterpriseid
																					);

																					if (matchedEnterprise?.siteData?.length > 0) {
																						const siteIds = matchedEnterprise.siteData.map((site: any) => site.siteId);
																						setCheckedSitesForUpdate(siteIds);
																					} else {
																						setCheckedSitesForUpdate([]);
																					}
																					handleUpdateCustomer(customer);
																					setSelectAllForSitesUpdate(true);
																				}} disableRipple>
																					Update All
																				</MenuItem>
																			)}
																			
																		</StyledMenu>
																	</ClickAwayListener>
																</Box>
															</Typography>
														</TableCell>
													</TableRow>
													{customerData?.index === index ? (
														siteList?.length > 0 ? (
															siteList.map((siteElement: any, index: any) => (
																<TableRow key={index} sx={{ background: '#192529' }}>
																	<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>{index + 1}</TableCell>
																	{/* {(siteElement?.vSaaSSiteStatus?.statusText === "ONLINE") && <TableCell sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src={siteOnlineIcon} alt="" width={24} height={24} /></TableCell>}
																	{siteElement?.cameraConnectivityStatus === undefined && <TableCell sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>&nbsp;</TableCell>}
																	{siteElement?.cameraConnectivityStatus == 1 &&
																	<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src={cameraOfflineIcon} alt="" width={24} height={24} /></TableCell>}
																	{siteElement?.cameraConnectivityStatus == 3 &&
																	<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src={cameraUnknownIcon} alt="" width={24} height={24} /></TableCell>}
																	{siteElement?.cameraConnectivityStatus == 0 &&
																	<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src={cameraOnlineIcon} alt="" width={24} height={24} /></TableCell>} */}
																	<TableCell
																		sx={{
																			color: '#B4B7B8',
																			fontSize: '14px',
																			borderColor: '#313838',
																			margin: 0,
																		}}
																	>
																		
																			<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
																				{siteElement?.vSaaSSiteStatus?.statusText === 'ONLINE' && (
																					<img src={siteOnlineIcon} alt="Site Online" width={16} height={16} />
																				)}
																				{siteElement?.vSaaSSiteStatus?.statusText === 'OFFLINE' && (
																					<img src={siteOfflineIcon} alt="Site Offline" width={16} height={16} />
																				)}
																				{siteElement?.vSaaSSiteStatus?.statusText === 'UNKNOWN' && (
																					<img src={siteOfflineIcon} alt="Site Unknown" width={16} height={16} />
																				)}
																				{siteElement?.cameraConnectivityStatus === undefined ? (
																					<img src={cameraUnknownIcon} alt="Camera Unknown" width={16} height={16} />
																				) : siteElement?.cameraConnectivityStatus === 1 ? (
																					<img src={cameraOfflineIcon} alt="Camera Offline" width={16} height={16} />
																				) : siteElement?.cameraConnectivityStatus === 3 ? (
																					<img src={cameraUnknownIcon} alt="Camera Unknown" width={16} height={16} />
																				) : siteElement?.cameraConnectivityStatus === 0 ? (
																					<img src={cameraOnlineIcon} alt="Camera Online" width={16} height={16} />
																				) : (
																					<>&nbsp;</>
																				)}
																			</Box>
																	</TableCell>

																	<TableCell
																		sx={{
																			color: '#B4B7B8',
																			fontSize: '14px',
																			borderColor: '#313838',
																			margin: '0',
																			paddingLeft: "39px",
																			position: "relative",
																			"&::before": {
																				content: '""',
																				position: "absolute",
																				top: "0",
																				left: "20px",
																				width: "100%",
																				height: "100%",
																				borderLeft: "1px solid #0699CE",
																				boxSizing: "border-box",
																			},
																			width: '250px'
																		}}
																	>
																		{/* {(i?.vSite?.status === "REGISTERED") && <img src={"/icons/green.png"} width="8" height="8" style={{ margin: "5px 15px" }} />}
																	{(i?.vSite?.status === "PENDING") && <span className="grey" style={{ margin: "5px 15px" }}></span>}
																	{i?.vSite?.status === "SUSPENDED" && <img src={"/icons/yellow.png"} width="8" height="8" style={{ margin: "5px 15px" }} />} */}


																		<Box sx={{ position: "absolute", top: "50%", left: "25px", transform: "translate(0, -50%)", display: "flex", flexDirection: "column" }}>
																			<Box sx={{ display: "flex", alignItems: "center", gap: "4px", marginLeft: "15px", maxWidth: "220px"}}>
																				{(siteElement?.vSaaSSiteStatus?.statusText === "ONLINE") && <img src={"/icons/green.png"} width="8" height="8" />}
																				{(siteElement?.vSaaSSiteStatus?.statusText === "OFFLINE" || siteElement?.vSaaSSiteStatus?.statusText === "UNKNOWN") && <img src={"/icons/red.png"} width="8" height="8" />}
																				{/* {siteElement?.vSite?.name} */}
																				<div
																					className="textEllipsis"
																					style={{ flex: 1 }}
																					title={siteElement?.vSite?.name}
																				>
																					{siteElement?.vSite?.name}
																				</div>
																			</Box>
																			<Box sx={{ display: "flex", flexDirection: "row" }}>
																				<Box sx={{ fontSize: "12px", fontWeight: "400", mt: "2px", color: getStatusColor(siteElement?.vSite?.status), border: "1px solid", borderColor: "gray", borderRadius: "20px", px: "8px", py: "2px", display: "inline-block", width: "fit-content", marginLeft: "15px" }}>
																					{toTitleCase(siteElement?.vSite?.status === "PENDING" ? "UNREGISTERED" : siteElement?.vSite?.status)}
																				</Box>
																				{/* <Box sx={{ fontSize: "12px", fontWeight: "400", mt: "2px", borderRadius: "20px", px: "8px", py: "2px", display: "inline-block", width: "fit-content", marginLeft: "15px" }}>
																					{siteElement?.currentVersion?.[0]}
																				</Box> */}
																			</Box>

																		</Box>
																	</TableCell>
																	<TableCell sx={{ padding: '0', borderColor: '#313838', margin: '0', textAlign: 'center', width: '250px' }}>
																		<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', }}><Image src={customer?.vEnterprise?.logourl} width="50" /></Typography>
																	</TableCell>
																	{/* <TableCell sx={{ padding: '0', borderColor: '#313838', margin: '0', maxWidth: "250px" }}>
																		<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', paddingLeft: '20px', margin: '0', maxWidth: '250px', }}>
																			{[siteElement?.vSite?.address?.addressline1,
																			siteElement?.vSite?.address?.addressline2,
																			siteElement?.vSite?.address?.city,
																			siteElement?.vSite?.address?.state,
																			siteElement?.vSite?.address?.postalcode,
																			siteElement?.vSite?.address?.country]
																				.filter(Boolean) // Filters out undefined, null, or empty values
																				.join(", ")}
																		</Typography>
																	</TableCell> */}

																	<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>

																		{siteElement?.vSite?.contact?.mobile?.[0]?.number}
																		{siteElement?.vSite?.contact?.mobile?.[0]?.number && siteElement?.vSite?.contact?.email?.[0]?.id ? <br /> : ''}
																		{siteElement?.vSite?.contact?.email?.[0]?.id}
																	</TableCell>

																	<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>{siteElement?.vCentralUsers?.[0]?.name} {siteElement?.vCentralUsers?.[0]?.lastName}</TableCell>
																	<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>{siteElement?.currentVersion?.[0] ? siteElement?.currentVersion?.[0] : siteElement?.vSite?.dockerTagVersion}</TableCell>
																	<TableCell sx={{ display: 'flex', gridGap: '10px', }}>
																		<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0', width: '100%', }}>
																			<Box sx={{ display: 'flex', gridGap: '10px', justifyContent: "space-evenly" }}>
																				<Typography sx={{ color: "#B4B7B8", fontSize: '14px', textAlign: "center" }}> <span className="green"></span><br/> {siteElement?.licenseCount?.active ?? 0}</Typography>
																				<Typography sx={{ color: "#B4B7B8", fontSize: '14px', textAlign: "center" }}><span className="yellow"></span><br/> {siteElement?.licenseCount?.suspended ?? 0}</Typography>
																				<Typography sx={{ color: "#B4B7B8", fontSize: '14px', textAlign: "center" }}><span className="red"></span><br/> {siteElement?.licenseCount?.expired ?? 0}</Typography>
																			</Box>
																		</Typography>

																	</TableCell>

																	<TableCell>
																		<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', padding: '0', margin: '0', }}>
																			<Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', position: 'relative' }}>
																				{/* {updatingSitesForAllCustomers?.some(
																					(item) =>
																						Array.isArray(item?.siteData) &&
																						item.siteData.some(
																							(site: { siteId: any; }) => site?.siteId === siteElement?.vSite?.siteId
																						)
																				) ? (
																					<Image
																						src={siteUpdatingInProgress?.[siteElement?.vSite?.siteId] ? updatingEdgeIcon : refreshEdgeIcon}
																						alt="Refresh"
																						style={{ cursor: 'pointer', width: 20, height: 20 }}
																						onClick={() => { setCheckedSitesForUpdate([siteElement?.vSite?.siteId]); setCheckedSitesNameForUpdate(siteElement?.vSite?.name); setUpdateEachSiteModalOpen(true); setUpdateSiteAction("Update"); setSelectedSiteForUpdate(siteElement)}}
																					/>
																				) : (
																					<Box sx={{ width: 20, height: 20 }} />
																				)} */}
																				{(() => {
																					if (siteElement?.vSite?.type == "CLOUD") {
																						return <Box sx={{ width: 20, height: 20 }} />;
																					}
																					else {
																					const siteId = siteElement?.vSite?.siteId;
																					const isSitePresent = updatingSitesForAllCustomers?.some(
																						(item) =>
																							Array.isArray(item?.siteData) &&
																							item.siteData.some(
																								(site: { siteId: any }) => site?.siteId === siteId
																							)
																					);
																					const isUpdating = siteUpdatingInProgress?.[siteId];

																					if (isSitePresent) {
																						return (
																							<Image
																								src={isUpdating ? updatingEdgeIcon : refreshEdgeIcon}
																								alt="Refresh"
																								style={{ cursor: "pointer", width: 20, height: 20 }}
																								onClick={() => {
																									setCheckedSitesForUpdate([siteId]);
																									setCheckedSitesNameForUpdate(siteElement?.vSite?.name);
																									setUpdateEachSiteModalOpen(true);
																									setUpdateSiteAction("Update");
																									setSelectedSiteForUpdate(siteElement);
																								}}
																							/>
																						);
																					} else if (isUpdating) {
																						return (
																							<Image
																								src={updatingEdgeIcon}
																								alt="Updating"
																								style={{ width: 20, height: 20 }}
																							/>
																						);
																					} else {
																						return <Box sx={{ width: 20, height: 20 }} />;
																					}}
																				})()}
																				<Image
																					src={eyeIcon}
																					alt="View"
																					style={{ cursor: 'pointer', width: 16, height: 16 }}
																					onClick={() => handleNavigate(customer, null, index)}
																				/>

																				<Image style={{ cursor: "pointer" }} src={threeDotsIcon} onClick={(e) => {
																					e.stopPropagation()
																					handleCustomAction(`${index}-child`)
																					handleClick(e);
																					fetchLicenseTableData(siteElement?.vSite?.siteId);
																					getEdgeCurrentVersion(siteElement?.vSite?.siteId);
																					
																				}} />
																				<StyledMenu
																					id="demo-customized-menu"
																					MenuListProps={{
																						'aria-labelledby': 'demo-customized-button',
																					}}
																					anchorEl={anchorEl}
																					open={customAction === `${index}-child`}
																					onClose={undefined}
																				>
																					<MenuItem onClick={() => handleAddSiteModalOpen(siteElement, "edit")} disableRipple>
																						Edit Site / Device Info
																					</MenuItem>
																					<MenuItem onClick={() => { setSuspendSiteAction(siteElement?.vSite?.status === "SUSPENDED" ? "Activate" : "Suspend"); setSuspendSiteModalOpen(true); setCustomerEnterpriseId(customer?.vEnterprise?.enterpriseid); setCustomerEnterpriseSiteId(siteElement?.vSite?.siteId) }} disableRipple>
																						{siteElement?.vSite?.status === "SUSPENDED" ? "Activate Site" : "Suspend Site"}
																					</MenuItem>
																					{siteOrderId && <MenuItem onClick={() => navigate("/orders/details", {
																						state: {
																							siteOrderId: siteOrderId,
																							siteId: siteElement?.vSite?.siteId,
																						},
																					})} disableRipple>
																						Orders
																					</MenuItem>}
																					<MenuItem onClick={() => { setDeleteSiteModalOpen(true); setCustomerEnterpriseId(customer?.vEnterprise?.enterpriseid); setCustomerEnterpriseSiteId(siteElement?.vSite?.siteId); }} disableRipple>
																						Delete Site
																					</MenuItem>
																					<MenuItem onClick={() => handleCheckRegStatusModalOpen(siteElement)} disableRipple>
																						Check Registration Status
																					</MenuItem>
																					{/* <MenuItem onClick={() => console.log("")} disableRipple>
																						Reboot
																					</MenuItem>
																					<MenuItem onClick={() => console.log("")} disableRipple>
																						Rollback1
																					</MenuItem> */}
																					{/* <MenuItem onClick={() => handleUpdateEachSiteModalOpen(siteElement)} disableRipple>
																						Update
																					</MenuItem> */}


																					{siteElement?.vSaaSSiteStatus?.statusText === "ONLINE" && (
																						<>
																							<MenuItem onClick={() => handleReboot(siteElement)} disableRipple>
																								Reboot
																							</MenuItem>

																							{loadingVersions ? (
																								<MenuItem disabled>
																									<Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
																										<CircularProgress size={16} /> Loading...
																									</Box>
																								</MenuItem>
																							) : (
																								<>
																									{siteElement?.vSite?.type !== "CLOUD" && siteElement?.currentVersion?.[1] > 0 &&
																										siteElement?.latestVersion?.[1] > 0 &&
																										siteElement?.currentVersion?.[1] < siteElement?.latestVersion?.[1] && (
																											<MenuItem onClick={() => {setCheckedSitesForUpdate([siteElement?.vSite?.siteId]); setCheckedSitesNameForUpdate(siteElement?.vSite?.name); setUpdateEachSiteModalOpen(true); setUpdateSiteAction("Update"); setSelectedSiteForUpdate(siteElement)}}>
																												Update to {siteElement?.latestVersion?.[0]}
																											</MenuItem>
																										)}

																									{siteElement?.vSite?.type !== "CLOUD" && siteElement?.currentVersion?.[1] > 0 &&
																										siteElement?.previousVersion?.[1] > 0 &&
																										siteElement?.currentVersion?.[1] > siteElement?.previousVersion?.[1] && (
																											<MenuItem onClick={() => {setCheckedSitesForUpdate([siteElement?.vSite?.siteId]); setCheckedSitesNameForUpdate(siteElement?.vSite?.name); setUpdateEachSiteModalOpen(true); setUpdateSiteAction("Rollback"); setSelectedSiteForUpdate(siteElement)}}>
																												Rollback to {siteElement?.previousVersion?.[0]}
																											</MenuItem>
																										)}
																								</>
																							)}
																						</>
																					)}
																				</StyledMenu>
																			</Box>
																		</Typography>
																	</TableCell>

																</TableRow>
															))
														) : (
															<TableRow sx={{ background: '#192529' }}>
																<TableCell
																	sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0', textAlign: 'center' }}
																	colSpan={10}
																>
																	{loader ? (
																		<CircularProgress color="primary" />
																	) : (
																		"No Data!"
																	)}
																</TableCell>
															</TableRow>
														)
													) : null}
												</>
											))
										) : (
											<TableRow>
												<TableCell colSpan={8} sx={{ textAlign: "center", color: "#a5a8a9" }}>
													No data available
												</TableCell>
											</TableRow>
										)
									) : isSearching ? (
										loader ? (
											<TableRow>
												<TableCell colSpan={8} sx={{ textAlign: "center" }}>
													<CircularProgress color="primary" />
												</TableCell>
											</TableRow>
										) : searchResult?.length > 0 ? (
												searchResult.map((customer: any, indexx: number) => (
													<>
														<TableRow sx={{ padding: '0', margin: '0', borderBottom: "1px solid #313838", cursor: "pointer" }} key={indexx}>
															<TableCell onClick={() => { updateShowSitelistStatus(customer?.vCustomerResponse?.vEnterprise?.enterpriseid);}} sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0', verticalAlign: 'sub' }}>{indexx + 1}</TableCell>

															<TableCell onClick={() => { updateShowSitelistStatus(customer?.vCustomerResponse?.vEnterprise?.enterpriseid);}} sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0', verticalAlign: 'sub' }}>
																<HtmlTooltip
																//Uncomment this-
																title={
																	<Box sx={{ backgroundColor: '#1D292E', p: 1 }}>
																		{/* {groupData.map((data: any, idx: number) => ( */}
																		<Box sx={{ pb: '12px', backgroundColor: '#1D292E' }}>
																			{/* <Typography sx={{ pb: '4px', fontSize: '12px' }}>{data.groupName}</Typography> */}
																			<Typography
																				color="#A5A8A9"
																				fontSize="14px"
																				display="flex"
																				alignItems="center"
																				flexDirection="row"
																				gap="8px"
																			>
																				<img src={siteOnlineIcon} alt="site online" /> {customer?.siteStatus?.numberOfOnlineSite}
																				<img src={siteOfflineIcon} alt="site offline" /> {customer?.siteStatus?.numberOfOfflineSite}
																			</Typography>

																			{/* Second line: Camera icons */}
																			<Typography
																				color="#A5A8A9"
																				fontSize="14px"
																				display="flex"
																				alignItems="center"
																				flexDirection="row"
																				gap="8px"
																				mt={1} // small top margin for spacing
																			>
																				<img src={cameraOnlineIcon} alt="camera online" /> {customer?.siteStatus?.numberOfOnlineChannel}
																				<img src={cameraOfflineIcon} alt="camera offline" /> {customer?.siteStatus?.numberOfOfflineChannel}
																				<img src={cameraUnknownIcon} alt="camera unknown" /> {customer?.siteStatus?.numberOfUnknownChannel}
																			</Typography>
																		</Box>
																		{/* ))} */}
																	</Box>
																}
																
																placement="right"
																slotProps={{
																	popper: {
																		modifiers: [
																			{
																				name: 'offset',
																				options: { offset: [8, 0] },
																			},
																		],
																	},
																}}
															>
																{customer?.siteStatus && <div className="pStatusBG">
																	{/* {(customer?.siteStatus?.connectivityStatus === undefined || customer?.vCustomerResponse?.siteStatus?.connectivityStatus === 1 || customer?.vCustomerResponse?.siteStatus?.pending === true) && <div className="statusBG" style={{ borderLeft: "2px solid red" }}><span className="red"></span></div>} */}
																	{/* {(customer?.siteStatus?.suspended === true) && <div className="statusBG" style={{ borderLeft: "2px solid yellow" }}><span className="yellow"></span></div>} */}
																<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
																{(customer?.siteStatus?.connectivityStatus === undefined || customer?.siteStatus?.connectivityStatus === 1 || customer?.siteStatus?.connectivityStatus === 3
																// || customer?.siteStatus?.pending === true
																 ) && 
																// <div className="statusBG" style={{ borderLeft: "2px solid red" }}><span className="red"></span></div>
																<img src={siteOfflineIcon} alt="" width={16} height={16} />
																}
																{(customer?.siteStatus?.connectivityStatus === 0) && 
																	<img src={siteOnlineIcon} alt="" width={16} height={16} />
																}
																{(customer?.siteStatus?.cameraConnectivityStatus === undefined || customer?.siteStatus?.cameraConnectivityStatus === 1) && 
																<img src={cameraOfflineIcon} alt="" width={16} height={16} />
																}
																{(customer?.siteStatus?.cameraConnectivityStatus === 0) && 
																<img src={cameraOnlineIcon} alt="" width={16} height={16} />
																}
																{(customer?.siteStatus?.cameraConnectivityStatus === 3) && 
																<img src={cameraUnknownIcon} alt="" width={16} height={16} />
																}
																</Box>
																</div>}
																</HtmlTooltip>
															</TableCell>

															<TableCell onClick={() => { updateShowSitelistStatus(customer?.vCustomerResponse?.vEnterprise?.enterpriseid);}} sx={{ borderColor: '#313838', margin: '0', display: 'flex', width: '250px' }}>
																<ExpandMoreIcon sx={{ cursor: 'pointer', color: '#B4B7B8', fontSize: '24px', display: 'inline-block', transform: customer.showSiteList ? 'rotate(180deg)' : 'rotate(0deg)', transition: '0.5s' }} />

																{customer?.vCustomerResponse?.vEnterprise?.status === 0 && <span className="green" style={{ padding: "4px", marginTop: "7px" }}></span>}
																{customer?.vCustomerResponse?.vEnterprise?.status === 1 && <span className="yellow" style={{ padding: "4px", marginTop: "7px" }}></span>}

																<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0'}}>
																	{customer?.vCustomerResponse?.vEnterprise?.name}
																</Typography>
															</TableCell>

															<TableCell onClick={() => { updateShowSitelistStatus(customer?.vCustomerResponse?.vEnterprise?.enterpriseid);}} sx={{ padding: '0', borderColor: '#313838', margin: '0', textAlign: 'center', width: '250px' }}>
																<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', }}><Image src={customer?.vCustomerResponse?.vEnterprise?.logourl} width="50" /></Typography>
															</TableCell>

															{/* <TableCell onClick={() => { updateShowSitelistStatus(customer?.vCustomerResponse?.vEnterprise?.enterpriseid);}} sx={{ padding: '0', borderColor: '#313838', margin: '0', }}>
																<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', paddingLeft: '20px', margin: '0', width: '300px', }}>
																	{[customer?.vCustomerResponse?.vEnterprise?.address?.addressline1,
																	customer?.vCustomerResponse?.vEnterprise?.address?.addressline2,
																	customer?.vCustomerResponse?.vEnterprise?.address?.city,
																	customer?.vCustomerResponse?.vEnterprise?.address?.state,
																	customer?.vCustomerResponse?.vEnterprise?.address?.postalcode,
																	customer?.vCustomerResponse?.vEnterprise?.address?.country]
																		.filter(Boolean) // Filters out undefined, null, or empty values
																		.join(", ")}
																</Typography>
															</TableCell> */}

															<TableCell onClick={() => { updateShowSitelistStatus(customer?.vCustomerResponse?.vEnterprise?.enterpriseid);}}>
																<Typography sx={{ color: '#B4B7B8', fontSize: '14px', margin: '0', width: '10%', }}>
																	{customer?.vCustomerResponse?.vEnterprise?.contact?.mobile?.[0]?.number}
																	{customer?.vCustomerResponse?.vEnterprise?.contact?.mobile?.[0]?.number && customer?.vCustomerResponse?.vEnterprise?.contact?.email?.[0]?.id ? <br /> : ''}
																	{customer?.vCustomerResponse?.vEnterprise?.contact?.email?.[0]?.id}
																</Typography>
															</TableCell>

															<TableCell onClick={() => { updateShowSitelistStatus(customer?.vCustomerResponse?.vEnterprise?.enterpriseid);}}>
																<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>{`${customer?.vCustomerResponse?.vCentralUsers?.[0]?.name || ""} ${customer?.vCustomerResponse?.vCentralUsers?.[0]?.lastName || ""}`}</Typography>
															</TableCell>
															<TableCell onClick={() => { updateShowSitelistStatus(customer?.vCustomerResponse?.vEnterprise?.enterpriseid);}} sx={{ padding: '0', borderColor: '#313838', margin: '0', textAlign: 'center', width: '150px' }}>
																<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', }}></Typography>
															</TableCell>
															<TableCell onClick={() => { updateShowSitelistStatus(customer?.vCustomerResponse?.vEnterprise?.enterpriseid);}} sx={{ width: '10%' }}>
																<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>
																	<Box sx={{ display: 'flex', gridGap: '10px', justifyContent: "space-evenly" }}>
																		<Typography sx={{ color: "#B4B7B8", fontSize: '14px', textAlign: "center" }}> <span className="green"></span><br/> {customer?.vCustomerResponse?.licenseCount?.active ?? 0}</Typography>
																		<Typography sx={{ color: "#B4B7B8", fontSize: '14px', textAlign: "center" }}><span className="yellow"></span><br/> {customer?.vCustomerResponse?.licenseCount?.suspended ?? 0}</Typography>
																		<Typography sx={{ color: "#B4B7B8", fontSize: '14px', textAlign: "center" }}><span className="red"></span><br/> {customer?.vCustomerResponse?.licenseCount?.expired ?? 0}</Typography>
																	</Box>
																</Typography>
															</TableCell>

															<TableCell sx={{ position: 'relative' }}>
																<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', padding: '0', margin: '0', }}>
																	<Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', position: 'relative'  }}>
																		{updatingSitesForAllCustomers.find(
																			(item: any) =>
																				item.enterpriseId === customer?.vCustomerResponse?.vEnterprise?.enterpriseid &&
																				item.siteData?.length > 0
																		) ? (
																			<Image
																				src={refreshEdgeIcon}
																				alt="Refresh"
																				style={{ cursor: 'pointer', width: 20, height: 20 }}
																				onClick={(e) => {
																					e.stopPropagation();
																					// const allSiteIds = customer?.vCustomerResponse?.vEnterprise?.sites || [];
																					// setCheckedSitesForUpdate(allSiteIds);
																					const matchedEnterprise = updatingSitesForAllCustomers.find(
																						(item: any) =>
																							item.enterpriseId === customer?.vCustomerResponse?.vEnterprise?.enterpriseid
																					);

																					if (matchedEnterprise?.siteData?.length > 0) {
																						const siteIds = matchedEnterprise.siteData.map((site: any) => site.siteId);
																						setCheckedSitesForUpdate(siteIds);
																					} else {
																						setCheckedSitesForUpdate([]);
																					}
																					handleUpdateCustomer(customer);
																					setSelectAllForSitesUpdate(true);
																				}}
																			/>
																		) : (
																			<Box sx={{ width: 20, height: 20 }} />
																		)}
																		<Link to={`/customer/details/${customer?.vCustomerResponse?.vEnterprise?.name}/${customer?.vCustomerResponse?.vEnterprise?.enterpriseid}`} style={{ cursor: "pointer !important" }}>
																			{customer?.vCustomerResponse?.vEnterprise?.status === 0 ? (
																				<Image src={eyeIcon} style={{ cursor: "pointer" }} className="aaaaaaaaaa" />
																			) : (
																				<Image src={eyeIcon} style={{ cursor: "not-allowed", opacity: 0.5 }} className="bbbbbbbbbbb" />
																			)}

																		</Link>

																		<Image src={threeDotsIcon}
																			onClick={(e) => {
																				e.stopPropagation();
																				setCustomerEnterpriseId(customer?.vCustomerResponse?.vEnterprise?.enterpriseid);
																				setCustomerTimeZone(customer?.vCustomerResponse?.vEnterprise?.timezone);
																				handleCustomAction(indexx);
																				handleClick(e);
																			}}
																			style={{ cursor: "pointer" }}
																		/>
																		<StyledMenu
																			id="demo-customized-menu"
																			MenuListProps={{
																				'aria-labelledby': 'demo-customized-button',
																			}}
																			anchorEl={anchorEl}
																			open={customAction === indexx}
																			onClose={undefined}
																			//onClick={(event) => event.stopPropagation()}
																		>
																			<MenuItem onClick={(e) => { e.stopPropagation(); handleEditCustomerModalOpen(customer?.vCustomerResponse); setCustomAction(null); }} disableRipple>
																				Edit Customer
																			</MenuItem>
																			{customer?.vCustomerResponse?.vCentralUsers?.length > 0 && (<MenuItem onClick={(e) => { e.stopPropagation(); handleEditCustomerAdminModalOpen(customer?.vCustomerResponse); setCustomAction(null); }} disableRipple>
																				Edit Customer Admin
																			</MenuItem>
																			)}
																			<MenuItem onClick={(e) => { e.stopPropagation(); handleAddSiteModalOpen(customer?.vCustomerResponse, "new"); setCustomAction(null); }} disableRipple>
																				Add New Site / Device
																			</MenuItem>
																			<MenuItem onClick={(e) => { e.stopPropagation(); setSuspendModalOpen(customer?.vCustomerResponse); setCustomerEnterpriseId(customer?.vCustomerResponse?.vEnterprise?.enterpriseid); setCustomAction(null); setSuspendCustomerAction(customer?.vCustomerResponse?.vEnterprise?.status === 0 ? "Suspend" : "Activate"); }} disableRipple>
																				{customer?.vCustomerResponse?.vEnterprise?.status === 0 ? "Suspend Customer" : "Activate Customer"}
																			</MenuItem>
																			{customer?.vCustomerResponse?.vCentralUsers?.length > 0 && (<MenuItem onClick={(e) => { e.stopPropagation(); resendPasswordResetEmail(customer?.vCustomerResponse); setCustomAction(null); }} disableRipple>
																				Resend Password Reset Email
																			</MenuItem>
																			)}
																			<MenuItem onClick={(e) => { e.stopPropagation(); setDeleteModalOpen(customer?.vCustomerResponse); setCustomerEnterpriseId(customer?.vCustomerResponse?.vEnterprise?.enterpriseid); setCustomAction(null); }} disableRipple>
																				Delete Customer
																			</MenuItem>
																			{updatingSitesForAllCustomers.find(
																				(item: any) =>
																					item.enterpriseId === customer?.vCustomerResponse?.vEnterprise?.enterpriseid &&
																					item.siteData?.length > 0
																			) && (
																				<MenuItem onClick={(e) => {
																					// const allSiteIds = customer?.vCustomerResponse?.vEnterprise?.sites || [];
																					// setCheckedSitesForUpdate(allSiteIds);
																					const matchedEnterprise = updatingSitesForAllCustomers.find(
																						(item: any) =>
																							item.enterpriseId === customer?.vCustomerResponse?.vEnterprise?.enterpriseid
																					);

																					if (matchedEnterprise?.siteData?.length > 0) {
																						const siteIds = matchedEnterprise.siteData.map((site: any) => site.siteId);
																						setCheckedSitesForUpdate(siteIds);
																					} else {
																						setCheckedSitesForUpdate([]);
																					}
																					handleUpdateCustomer(customer);
																					setSelectAllForSitesUpdate(true);
																				}} disableRipple>
																					Update All
																				</MenuItem>
																			)}
																		</StyledMenu>
																	</Box>
																</Typography>
															</TableCell>
														</TableRow>
														{customer.showSiteList ? (
															customer?.vCustomerSiteResponseList?.length > 0 ? (
																customer?.vCustomerSiteResponseList?.map((siteElement: any, index: any) => (
																	<TableRow key={index} sx={{ background: '#192529' }}>
																		<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>{index + 1}</TableCell>
																		<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>
																			<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
																				{siteElement?.vSaaSSiteStatus?.statusText === 'ONLINE' && (
																					<img src={siteOnlineIcon} alt="Site Online" width={16} height={16} />
																				)}
																				{siteElement?.vSaaSSiteStatus?.statusText === 'OFFLINE' && (
																					<img src={siteOfflineIcon} alt="Site Offline" width={16} height={16} />
																				)}
																				{siteElement?.vSaaSSiteStatus?.statusText === 'UNKNOWN' && (
																					<img src={siteOfflineIcon} alt="Site Unknown" width={16} height={16} />
																				)}
																				{siteElement?.cameraConnectivityStatus === undefined ? (
																					<img src={cameraUnknownIcon} alt="Camera Unknown" width={16} height={16} />
																				) : siteElement?.cameraConnectivityStatus === 1 ? (
																					<img src={cameraOfflineIcon} alt="Camera Offline" width={16} height={16} />
																				) : siteElement?.cameraConnectivityStatus === 3 ? (
																					<img src={cameraUnknownIcon} alt="Camera Unknown" width={16} height={16} />
																				) : siteElement?.cameraConnectivityStatus === 0 ? (
																					<img src={cameraOnlineIcon} alt="Camera Online" width={16} height={16} />
																				) : (
																					<>&nbsp;</>
																				)}
																			</Box>
																		</TableCell>
																		<TableCell
																			sx={{
																				color: '#B4B7B8',
																				fontSize: '14px',
																				borderColor: '#313838',
																				margin: '0',
																				paddingLeft: "39px",
																				position: "relative",
																				"&::before": {
																					content: '""',
																					position: "absolute",
																					top: "0",
																					left: "20px",
																					width: "100%",
																					height: "100%",
																					borderLeft: "1px solid #0699CE",
																					boxSizing: "border-box",
																				},
																				width: '250px'
																			}}
																		>


																			<Box sx={{ position: "absolute", top: "50%", left: "25px", transform: "translate(0, -50%)", display: "flex", flexDirection: "column" }}>
																				<Box sx={{ display: "flex", alignItems: "center", gap: "4px", marginLeft: "15px" }}>
																					{(siteElement?.vSaaSSiteStatus?.statusText === "ONLINE") && <img src={"/icons/green.png"} width="8" height="8" />}
																					{(siteElement?.vSaaSSiteStatus?.statusText === "OFFLINE" || siteElement?.vSaaSSiteStatus?.statusText === "UNKNOWN") && <img src={"/icons/red.png"} width="8" height="8" />}
																					{siteElement?.vSite?.name}
																				</Box>
																				<Box sx={{ display: "flex", flexDirection: "row" }}>
																					<Box sx={{ fontSize: "12px", fontWeight: "400", mt: "2px", color: getStatusColor(siteElement?.vSite?.status), border: "1px solid", borderColor: "gray", borderRadius: "20px", px: "8px", py: "2px", display: "inline-block", width: "fit-content", marginLeft: "15px" }}>
																						{toTitleCase(siteElement?.vSite?.status === "PENDING" ? "UNREGISTERED" : siteElement?.vSite?.status)}
																					</Box>
																					{/* <Box sx={{ fontSize: "12px", fontWeight: "400", mt: "2px", borderRadius: "20px", px: "8px", py: "2px", display: "inline-block", width: "fit-content", marginLeft: "15px" }}>
																						{siteElement?.currentVersion?.[0]}
																					</Box> */}
																				</Box>

																			</Box>
																		</TableCell>
																		<TableCell sx={{ padding: '0', borderColor: '#313838', margin: '0', textAlign: 'center', width: '250px' }}>
																			<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', }}><Image src={customer?.vCustomerResponse?.vEnterprise?.logourl} width="50" /></Typography>
																		</TableCell>
																		{/* <TableCell sx={{ padding: '0', borderColor: '#313838', margin: '0', }}>
																			<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', paddingLeft: '20px', margin: '0', width: '300px', }}>
																				{[siteElement?.vSite?.address?.addressline1,
																				siteElement?.vSite?.address?.addressline2,
																				siteElement?.vSite?.address?.city,
																				siteElement?.vSite?.address?.state,
																				siteElement?.vSite?.address?.postalcode,
																				siteElement?.vSite?.address?.country]
																					.filter(Boolean) // Filters out undefined, null, or empty values
																					.join(", ")}
																			</Typography>
																		</TableCell> */}

																		<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>

																			{siteElement?.vSite?.contact?.mobile?.[0]?.number}
																			{siteElement?.vSite?.contact?.mobile?.[0]?.number && siteElement?.vSite?.contact?.email?.[0]?.id ? <br /> : ''}
																			{siteElement?.vSite?.contact?.email?.[0]?.id}
																		</TableCell>

																		<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>{siteElement?.vCentralUsers?.[0]?.name} {siteElement?.vCentralUsers?.[0]?.lastName}</TableCell>
																		<TableCell sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0' }}>{siteElement?.currentVersion?.[0] ? siteElement?.currentVersion?.[0] : siteElement?.vSite?.dockerTagVersion}</TableCell>
																		<TableCell sx={{ display: 'flex', gridGap: '10px', }}>
																			<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', margin: '0', width: '100%', }}>
																				<Box sx={{ display: 'flex', gridGap: '10px', justifyContent: "space-evenly" }}>
																					<Typography sx={{ color: "#B4B7B8", fontSize: '14px', textAlign: "center" }}> <span className="green"></span><br/> {siteElement?.licenseCount?.active ?? 0}</Typography>
																					<Typography sx={{ color: "#B4B7B8", fontSize: '14px', textAlign: "center" }}><span className="yellow"></span><br/> {siteElement?.licenseCount?.suspended ?? 0}</Typography>
																					<Typography sx={{ color: "#B4B7B8", fontSize: '14px', textAlign: "center" }}><span className="red"></span><br/> {siteElement?.licenseCount?.expired ?? 0}</Typography>
																				</Box>
																			</Typography>

																		</TableCell>

																		<TableCell>
																			<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', padding: '0', margin: '0', }}>
																				<Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', position: 'relative'}}>
																					{/* {updatingSitesForAllCustomers?.some(
																						(item) =>
																							Array.isArray(item?.siteData) &&
																							item.siteData.some(
																								(site: { siteId: any; }) => site?.siteId === siteElement?.vSite?.siteId
																							)
																					) ? (
																						<Image
																							src={!siteUpdatingInProgress?.[siteElement?.vSite?.siteId] ? updatingEdgeIcon : refreshEdgeIcon}
																							alt="Refresh"
																							style={{ cursor: 'pointer', width: 20, height: 20 }}
																							onClick={() => { setCheckedSitesForUpdate([siteElement?.vSite?.siteId]); setCheckedSitesNameForUpdate(siteElement?.vSite?.name); setUpdateEachSiteModalOpen(true); setUpdateSiteAction("Update"); setSelectedSiteForUpdate(siteElement)}}
																						/>
																					) : (
																						<Box sx={{ width: 20, height: 20 }} />
																					)} */}
																					{(() => {
																					if (siteElement?.vSite?.type == "CLOUD") {
																						return <Box sx={{ width: 20, height: 20 }} />;
																					}
																					else{
																						const siteId = siteElement?.vSite?.siteId;
																						const isSitePresent = updatingSitesForAllCustomers?.some(
																							(item) =>
																								Array.isArray(item?.siteData) &&
																								item.siteData.some(
																									(site: { siteId: any }) => site?.siteId === siteId
																								)
																						);
																						const isUpdating = siteUpdatingInProgress?.[siteId];

																						if (isSitePresent) {
																							return (
																								<Image
																									src={isUpdating ? updatingEdgeIcon : refreshEdgeIcon}
																									alt="Refresh"
																									style={{ cursor: "pointer", width: 20, height: 20 }}
																									onClick={() => {
																										setCheckedSitesForUpdate([siteId]);
																										setCheckedSitesNameForUpdate(siteElement?.vSite?.name);
																										setUpdateEachSiteModalOpen(true);
																										setUpdateSiteAction("Update");
																										setSelectedSiteForUpdate(siteElement);
																									}}
																								/>
																							);
																						} else if (isUpdating) {
																							return (
																								<Image
																									src={updatingEdgeIcon}
																									alt="Updating"
																									style={{ width: 20, height: 20 }}
																								/>
																							);
																						} else {
																							return <Box sx={{ width: 20, height: 20 }} />;
																						}}
																					})()}
																					<p onClick={() => handleNavigate(customer, siteElement, index)}>
																						<Image src={eyeIcon} style={{ cursor: "pointer" }} />
																					</p>
																					<Image style={{ cursor: "pointer" }} src={threeDotsIcon} onClick={(e) => {
																						e.stopPropagation()
																						handleCustomAction(`${siteElement?.vSite?.siteId}-child`)
																						handleClick(e);
																						fetchLicenseTableData(siteElement?.vSite?.siteId);
																					}} />
																					<StyledMenu
																						id="demo-customized-menu"
																						MenuListProps={{
																							'aria-labelledby': 'demo-customized-button',
																						}}
																						anchorEl={anchorEl}
																						open={customAction === `${siteElement?.vSite?.siteId}-child`}
																						onClose={undefined}
																					>
																						<MenuItem onClick={(e) => handleAddSiteModalOpen(siteElement, "edit")} disableRipple>
																							Edit Site / Device Info
																						</MenuItem>
																						<MenuItem onClick={() => { setSuspendSiteAction(siteElement?.vSite?.status === "SUSPENDED" ? "Activate" : "Suspend"); setSuspendSiteModalOpen(true); setCustomerEnterpriseId(customer?.vCustomerResponse?.vEnterprise?.enterpriseid); setCustomerEnterpriseSiteId(siteElement?.vSite?.siteId) }} disableRipple>
																							{siteElement?.vSite?.status === "SUSPENDED" ? "Activate Site" : "Suspend Site"}
																						</MenuItem>
																						<MenuItem onClick={() => navigate("/orders/details", {
																							state: {
																								siteOrderId: siteOrderId,
																								siteId: siteElement.vSite.siteId,
																							},
																						})} disableRipple>
																							Orders
																						</MenuItem>
																						<MenuItem onClick={() => { setDeleteSiteModalOpen(true); setCustomerEnterpriseId(customer?.vCustomerResponse?.vEnterprise?.enterpriseid); setCustomerEnterpriseSiteId(siteElement?.vSite?.siteId); }} disableRipple>
																							Delete Site
																						</MenuItem>
																						<MenuItem onClick={() => handleCheckRegStatusModalOpen(siteElement)} disableRipple>
																							Check Registration Status
																						</MenuItem>
																						{/* <MenuItem onClick={() => console.log("")} disableRipple>
																							Reboot
																						</MenuItem>
																						<MenuItem onClick={() => console.log("")} disableRipple>
																							Rollback
																						</MenuItem>
																						<MenuItem onClick={() => setUpdateEachSiteModalOpen(true)} disableRipple>
																							Update
																						</MenuItem> */}

																						{siteElement?.vSaaSSiteStatus?.statusText === "ONLINE" && (
																							<>
																								<MenuItem onClick={() => handleReboot(siteElement)} disableRipple>
																									Reboot
																								</MenuItem>

																								{loadingVersions ? (
																									<MenuItem disabled>
																										<Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
																											<CircularProgress size={16} /> Loading...
																										</Box>
																									</MenuItem>
																								) : (
																									<>
																										{siteElement?.vSite?.type !== "CLOUD" && siteElement?.currentVersion?.[1] > 0 &&
																											siteElement?.latestVersion?.[1] > 0 &&
																											siteElement?.currentVersion?.[1] < siteElement?.latestVersion?.[1] && (
																												<MenuItem onClick={() => {setCheckedSitesForUpdate([siteElement?.vSite?.siteId]); setCheckedSitesNameForUpdate(siteElement?.vSite?.name); setUpdateEachSiteModalOpen(true); setUpdateSiteAction("Update"); setSelectedSiteForUpdate(siteElement)}}>
																													Update to {siteElement?.latestVersion?.[0]}
																												</MenuItem>
																											)}

																										{siteElement?.vSite?.type !== "CLOUD" && siteElement?.currentVersion?.[1] > 0 &&
																											siteElement?.previousVersion?.[1] > 0 &&
																											siteElement?.currentVersion?.[1] > siteElement?.previousVersion?.[1] && (
																												<MenuItem onClick={() => {setCheckedSitesForUpdate([siteElement?.vSite?.siteId]); setCheckedSitesNameForUpdate(siteElement?.vSite?.name); setUpdateEachSiteModalOpen(true); setUpdateSiteAction("Rollback"); setSelectedSiteForUpdate(siteElement)}}>
																													Rollback to {siteElement?.previousVersion?.[0]}
																												</MenuItem>
																											)}
																									</>
																								)}
																							</>
																						)}





																					</StyledMenu>

																				</Box>
																			</Typography>
																		</TableCell>

																	</TableRow>
																))
															) : (
																<TableRow sx={{ background: '#192529' }}>
																	<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0', textAlign: 'center' }} colSpan={10}>
																		{loader ? (
																			<CircularProgress color="primary" />
																		) : (
																			"No Data!"
																		)}
																	</TableCell>
																</TableRow>
															)
														) : null }
													</>
												))
											) : (
												<TableRow>
													<TableCell colSpan={8} sx={{ textAlign: "center", color: "#a5a8a9" }}>
														{!initiateSearch ? "No Match Found!" : <CircularProgress color="primary" />}
													</TableCell>
												</TableRow>
											)
										) : (
										<TableRow>
											<TableCell colSpan={8} sx={{ textAlign: "center", color: "#a5a8a9" }}>
												<CircularProgress color="error" />
											</TableCell>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</TableContainer>

					</Box>
				</Box>
			</Box>


			{editCustomerModalOpen &&
				<Modal
					open={editCustomerModalOpen}
					onClose={handleEditCustomerModalClose}
					className="AddFeatureM"
				>
					<Box sx={{
						maxWidth: '736px',
						width: '100%',
						margin: '64px auto 0',
						padding: '24px',
						borderRadius: '30px',
						borderColor: '#5A5F60 !important',
						border: '1px solid',
					}}
					>
						<Typography variant="h6" component="h2" gutterBottom
							sx={{
								fontSize: '20px',
								color: '#E2E3E3',
								borderBottom: '1px solid #5A5F60',
								paddingBottom: '10px',
								marginBottom: '30px',
							}}
						>
							Edit Customer - {customerUserName}
							<span onClick={handleEditCustomerModalClose}><CloseIcon style={{ float: "right", cursor: "pointer" }}></CloseIcon></span>
						</Typography>

						<Formik
							initialValues={customerInitialValues}
							enableReinitialize={true} // Enable reinitialization
							validationSchema={object({
								partnerid: string().trim().required("Partnerid is required!"),
								name: string().trim().required("Customer name is required!"),
								email: string().email().required("Email ID is required!"),
								addressline1: string().trim().optional(),
								addressline2: string().trim().optional(),
								postalcode: string().trim().optional(),
								city: string().nullable().optional(),
								state: string().nullable().optional(),
								country: string().nullable().optional(),
								timezone: string().nullable().optional(),
								number: string().min(2, "Must be at least 2 digits").max(10, "Cannot be more than 10 digits").optional(),
								mobile: string().trim().optional(),
								customerprofileimage: mixed()
									.nullable()
									.optional()
									.test(
										"fileSize",
										"File size should be less than 5MB",
										(value) => {
											if (!value) return true; // Skip validation if value is not present (for optional files)
											const file = value as File; // Explicitly cast value to File type
											return file.size <= 5 * 1024 * 1024; // Check file size
										}
									)
									.test(
										"fileType",
										"Unsupported file format. Only JPEG, PNG are allowed.",
										(value) => {
											if (!value) return true; // Skip validation if value is not present (for optional files)
											const file = value as File; // Explicitly cast value to File type
											return ["image/jpeg", "image/png"].includes(file.type); // Check file type
										}
									),
							})}
							onSubmit={async (values, { setSubmitting }) => {
								let temp_values = { ...values };
								temp_values.country = country;
								temp_values.state = state;
								temp_values.city = city;
								temp_values.timezone = customerTimeZone;
								if (temp_values.mobile != "" && !temp_values.mobile.includes("+")) {
									temp_values = { ...temp_values, mobile: `+${temp_values.mobile}` }
								}

								const resp = await putFormMethod(`customer/${temp_values.enterpriseid}`, temp_values);
								if (resp?.status === 200) {
									if(!isSearching) fetchCustomerList();
									else handleSearch(searchText);
									setToast(resp?.data?.message, "success");
									setEditCustomerModalOpen(false);
								} else {
									setToast(resp?.data?.message, "error");
								}
							}}
						>
							{({ values, isSubmitting, setFieldValue, errors, touched }) => (
								<Form>
									<Grid container spacing={2} className="customer_popup" style={{ paddingBottom: "30px", paddingRight: "8px" }}>
										<Grid size={{ xs: 12, sm: 6 }}>
											<RBFORM.Group>
												<Typography variant="subtitle1"
													sx={{
														color: '#B4B7B8',
														fontSize: '14px',
													}}
												> Email ID<span style={{ color: "red" }}>*</span></Typography>
												<Field
													name="email"
													type="text"
													component={formikTextField}
													className="inputC"
												/>
											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, sm: 6 }}>
											<RBFORM.Group>
												<Typography variant="subtitle1"
													sx={{
														color: '#B4B7B8',
														fontSize: '14px',
													}}
												> Customer Name<span style={{ color: "red" }}>*</span></Typography>
												<Field
													name="name"
													as="input"
													type="text"
													component={formikTextField}
													className="inputC"
												/>
											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, sm: 12 }}>
											<RBFORM.Group>
												<Typography variant="subtitle1"
													sx={{
														color: '#B4B7B8',
														fontSize: '14px',
													}}
												> Address Line 1</Typography>
												<Field
													name="addressline1"
													as="input"
													type="text"
													component={formikTextField}
													className="inputC"
												/>

											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, sm: 12 }}>
											<RBFORM.Group>
												<Typography variant="subtitle1"
													sx={{
														color: '#B4B7B8',
														fontSize: '14px',
													}}
												> Address Line 2</Typography>
												<Field
													name="addressline2"
													as="input"
													type="text"
													component={formikTextField}
													className="inputC"
												/>
											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, md: 6 }}>
											<RBFORM.Group>
												<RBFORM.Label className="label">Country</RBFORM.Label>
												<Field
													name="country"
													as="select"
													className="inputC custDropdown"
													onChange={(e: any) => handleCountryChange(e, setFieldValue)}
												>
													{countryList?.length > 0 ? (
														countryList.map((country: any) => (
															<option key={country.id} value={country.id}>
																{country.name}
															</option>
														))
													) : (
														<option>Select Country</option>
													)}
												</Field>
											</RBFORM.Group>
										</Grid>


										<Grid size={{ xs: 12, md: 6 }}>
											<RBFORM.Group>
												<RBFORM.Label className="label">State</RBFORM.Label>
												<Field
													name="state"
													as="select"
													placeholder="State"
													className="inputC custDropdown"
													onChange={(e: any) => handleStateChange(e, setFieldValue)}
												>
													{filteredStateList?.length > 0 ? (
														filteredStateList.map((state: any) => (
															<option key={state.id} value={state.id}>
																{state.name}
															</option>
														))
													) : (
														<option>Select State</option>
													)}
												</Field>
											</RBFORM.Group>
										</Grid>


										<Grid size={{ xs: 12, md: 6 }}>
											<RBFORM.Group>
												<RBFORM.Label className="label">City</RBFORM.Label>
												<Field
													name="city"
													as="select"
													placeholder="City"
													className="inputC custDropdown"
													onChange={(e: any) => handleCityChange(e, setFieldValue)}
												>
													{filteredCityList?.length > 0 ? (
														filteredCityList.map((city: any) => (
															<option key={city.id} value={city.id}>
																{city.name}
															</option>
														))
													) : (
														<option>Select City</option>
													)}
												</Field>
											</RBFORM.Group>
										</Grid>


										<Grid size={{ xs: 12, md: 6 }}>
											<RBFORM.Group>
												<RBFORM.Label className="label">Postal Code</RBFORM.Label>
												<Field
													name="postalcode"
													type="text"
													placeholder="Enter Postal Code"
													component={formikTextField}
													className="inputC"
												/>
											</RBFORM.Group>
										</Grid>


										<Grid size={{ xs: 12, md: 6 }}>
											<RBFORM.Group>
												<RBFORM.Label className="label">Phone Number</RBFORM.Label>
												<Field
													name="number"
													type="text"
													placeholder="Enter Phone Number"
													component={formikTextField}
													className="inputC"
												/>
											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, md: 6 }}>
											<RBFORM.Group>
												<RBFORM.Label className="label">Mobile Number</RBFORM.Label>
												<PhoneInput
													country={'us'}
													specialLabel=""
													dropdownClass="user-phone-input-dropdown"
													containerClass="user-phone-input-container"
													inputClass={`${errors.mobile ? "errors" : ""} modalForm-input user-phone-input`}
													inputStyle={{
														boxShadow: 'none',
														color: "#A5A8A9",
														border: "1px solid #313838 !important",
														width: "100%",
														height: "40px",
														backgroundColor: "#192529",
													}}
													value={values.mobile}
													onChange={(number) => setFieldValue("mobile", number)}
												/>
											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, md: 12 }}>
											<RBFORM.Group>
												<RBFORM.Label className="label">Timezone </RBFORM.Label>
												<Field
													name="timezone"
													as="select"
													className="inputC custDropdown"
													onChange={(e: any) => handleTimeZoneChange(e, setFieldValue)}
													style={{ cursor: "pointer" }}
												>
													<option disabled>Select</option>
													{timezoneList.map((tz) => (
														<option key={tz.value} value={tz.value}>
															{tz.label}
														</option>
													))}

												</Field>
											</RBFORM.Group>
										</Grid>

										<div style={{ display: "flex", alignItems: "center" }}>
											<span>
												<img src={noteIcon} style={{ width: "20px", height: "20px" }} />
											</span>
											<span
												className="label"
												style={{ marginLeft: "8px", marginTop: "1.5px", fontSize: "14px", fontWeight: "400", whiteSpace: "nowrap" }}
											>
												Note: If Timezone is not set, UTC time will be set as default
											</span>
										</div>

										<Grid size={{ xs: 12, md: 12 }}>
											<RBFORM.Group className="UploadFld">
												<RBFORM.Label className="label">Upload Customer Logo</RBFORM.Label>
												<input
													name="customerprofileimage"
													type="file"
													className="inputC UploadIn"
													onChange={(e: any) => {
														setFieldValue("customerprofileimage", e.currentTarget.files[0]);
														previewImage(e, "customerprofileimage");
													}}
													id='file'
													ref={customerInputFile}
													style={{ display: 'none' }}
												/>
												<Box
													className="UploadIcon1"
													onClick={() => handleInputFile('customer')}
													style={{ width: '100%', height: '120px', border: '1px dashed #5A5F60', borderRadius: '8px', background: '#192529', textAlign: 'center', verticalAlign: 'middle' }}>
													{customerLogoFile && <img src={customerLogoFile} style={{ height: '100%', width: 'auto', float: 'left' }} />}
													<Box className="UploadIcon" style={{ top: "80px", cursor: 'pointer' }}>
														<img src={UploadIn} alt="" width={24} height={24} /> Upload Logo
													</Box>
												</Box>
												{/* {errors.customerprofileimage && touched.customerprofileimage && (
													<div style={{ color: "#d32f2f", fontSize: "0.75rem" }}>Customer logo is required!</div>
												)} */}
											</RBFORM.Group>
										</Grid>
									</Grid>

									<input type="hidden" name="enterpriseid" />
									{/* {JSON.stringify(values, null, 2)} */}

									<Box sx={{ display: "flex", borderTop: "1px solid #5A5F60", paddingTop: '20px', justifyContent: "flex-end", gap: 2 }}>
										<Button type="button" onClick={handleEditCustomerModalClose} variant="outlined"
											sx={{ color: '#0699CE', textTransform: 'capitalize', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}
										>
											Cancel
										</Button>
										<Button
											type="submit"
											variant="contained"
											disabled={isSubmitting}
											sx={{
												color: '#1F2F34', height: '41px', lineHeight: '41px',
												borderColor: '#0B4A62', background: '#17B2EB',
												borderRadius: '25px', fontSize: '14px',
												fontWidth: '500',
												textTransform: 'capitalize',
											}}
										>
											Save Changes
										</Button>
									</Box>
								</Form>
							)}
						</Formik>
					</Box>
				</Modal>
			}


			{addSiteModalOpen &&
				<Modal
					open={addSiteModalOpen}
					onClose={handleAddSiteModalClose}
					className="AddFeatureM"
				>
					<Box sx={{
						maxWidth: '736px',
						width: '100%',
						margin: '64px auto 0',
						padding: '24px',
						borderRadius: '30px',
						borderColor: '#5A5F60 !important',
						border: '1px solid',

					}}
					>
						<Typography variant="h6" component="h2" gutterBottom
							sx={{
								fontSize: '20px',
								color: '#E2E3E3',
								borderBottom: '1px solid #5A5F60',
								paddingBottom: '10px',
								marginBottom: '30px',
							}}
						>
							{!siteEdit ? "Add New Site / Device" : "Edit Site / Device Info"}
							<span onClick={handleAddSiteModalClose}><CloseIcon style={{ float: "right", cursor: "pointer" }}></CloseIcon></span>
						</Typography>

						<Formik
							initialValues={siteInitialValues}
							enableReinitialize={true} // Enable reinitialization
							validationSchema={object({
								enterpriseid: string().trim().required("Enterpriseid is required!"),
								name: string().trim().required("Site name / device is required!"),
								uniqueid: string().trim().required("Unique ID is required!"),
								email: string().email().required("Email ID is required!"),
								type: string().required("Type is required!"),
								addressline1: string().trim().optional(),
								addressline2: string().trim().optional(),
								postalcode: string().trim().optional(),
								city: string().nullable().optional(),
								state: string().nullable().optional(),
								country: string().nullable().optional(),
								number: string().min(2, "Must be at least 2 digits").max(10, "Cannot be more than 10 digits").optional(),
								mobile: string().trim().optional(),
								timezone: string().nullable().optional(),
							})}
							onSubmit={async (values, { setSubmitting }) => {
								try{
								let temp_values: any = { ...values };
								temp_values.country = country;
								temp_values.state = state;
								temp_values.city = city;
								temp_values.timezone = customerTimeZone;
								// delete temp_values['uniqueid'];

								if (temp_values?.mobile != "" && !temp_values.mobile?.includes("+")) {
									temp_values = { ...temp_values, mobile: `+${temp_values.mobile}` }
								}

								
								let api_endpoint = "";
								let resp;
								if (!siteEdit) {
									api_endpoint = `customer/site`;
									resp = await postMethodFormData(api_endpoint, temp_values);
								} else {
									api_endpoint = `customer/site/${siteId}`;
									resp = await putFormMethod(api_endpoint, temp_values);
								}

								if (resp?.status === 200) {
									if(!isSearching) {
										if (customerData?.customer?.vEnterprise?.enterpriseid) {
											await fetchCusomerSites(customerData?.customer?.vEnterprise?.enterpriseid);
										}
									} else {
										handleSearch(searchText);
									}
									setToast(resp?.data?.message, "success");
									setAddSiteModalOpen(false);
								} else {
									setToast(resp?.data?.message, "error");
								}
							}
								catch (err) {
									console.error("SUBMIT ERROR", err);
								} finally {
									setSubmitting(false);  
								}
						}}
						>
							{({ values, isSubmitting, setFieldValue, errors, touched }) => (

								
								<>
								<Form>
									<Grid container spacing={2} className="customer_popup" style={{ paddingBottom: "30px", paddingRight: "8px" }}>
										<Grid size={{ xs: 12, sm: 6 }}>
											<RBFORM.Group>
												<Typography variant="subtitle1"
													sx={{
														color: '#B4B7B8',
														fontSize: '14px',
													}}
												> Site / Device Name<span style={{ color: "red" }}>*</span></Typography>
												<Field
													name="name"
													as="input"
													type="text"
													component={formikTextField}
													className="inputC"
													placeholder="Enter Site / Sevice Name"
												/>
											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, sm: 6 }}>
											<RBFORM.Group>
												<Typography variant="subtitle1"
													sx={{
														color: '#B4B7B8',
														fontSize: '14px',
													}}
												> Unique ID<span style={{ color: "red" }}>*</span></Typography>
												<Field
													name="uniqueid"
													as="input"
													type="text"
													component={formikTextField}
													className="inputC"
													placeholder="Enter Unique ID"
												/>
											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, sm: 6 }}>
											<RBFORM.Group>
												<Typography variant="subtitle1"
													sx={{
														color: '#B4B7B8',
														fontSize: '14px',
													}}
												> Type<span style={{ color: "red" }}>*</span></Typography>
												<Field
													name="type"
													as="select"
													placeholder="type"
													className="inputC custDropdown"
												>
													<option value="EDGE">EDGE</option>
													<option value="CLOUD">CLOUD</option>
												</Field>
											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, sm: 6 }}>
											<RBFORM.Group>
												<Typography variant="subtitle1"
													sx={{
														color: '#B4B7B8',
														fontSize: '14px',
													}}
												> Email ID<span style={{ color: "red" }}>*</span></Typography>
												<Field
													name="email"
													type="text"
													component={formikTextField}
													className="inputC"
													placeholder="Enter Email ID"
												/>
											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, sm: 12 }}>
											<RBFORM.Group>
												<Typography variant="subtitle1"
													sx={{
														color: '#B4B7B8',
														fontSize: '14px',
													}}
												> Address Line 1</Typography>
												<Field
													name="addressline1"
													as="input"
													type="text"
													component={formikTextField}
													className="inputC"
													placeholder="Street address / company name / c/o"
												/>

											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, sm: 12 }}>
											<RBFORM.Group>
												<Typography variant="subtitle1"
													sx={{
														color: '#B4B7B8',
														fontSize: '14px',
													}}
												> Address Line 2</Typography>
												<Field
													name="addressline2"
													as="input"
													type="text"
													component={formikTextField}
													className="inputC"
													placeholder="Apartment / unit / building"
												/>
											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, md: 6 }}>
											<RBFORM.Group>
												<RBFORM.Label className="label">Country</RBFORM.Label>
												<Field
													name="country"
													as="select"
													className="inputC custDropdown"
													onChange={(e: any) => handleCountryChange(e, setFieldValue)}
												>
													{countryList?.length > 0 ? (
														countryList.map((country: any) => (
															<option key={country.id} value={country.id}>
																{country.name}
															</option>
														))
													) : (
														<option>Select Country</option>
													)}
												</Field>
											</RBFORM.Group>
										</Grid>


										<Grid size={{ xs: 12, md: 6 }}>
											<RBFORM.Group>
												<RBFORM.Label className="label">State</RBFORM.Label>
												<Field
													name="state"
													as="select"
													placeholder="State"
													className="inputC custDropdown"
													onChange={(e: any) => handleStateChange(e, setFieldValue)}
												>
													{filteredStateList?.length > 0 ? (
														<>
															<option>Select State</option>
															{filteredStateList.map((state: any) => (
																<option key={state.id} value={state.id}>
																	{state.name}
																</option>
															))}
														</>
													) : (
														<option>Select State</option>
													)}
												</Field>
											</RBFORM.Group>
										</Grid>


										<Grid size={{ xs: 12, md: 6 }}>
											<RBFORM.Group>
												<RBFORM.Label className="label">City</RBFORM.Label>
												<Field
													name="city"
													as="select"
													placeholder="City"
													className="inputC custDropdown"
													onChange={(e: any) => handleCityChange(e, setFieldValue)}
												>
													{filteredCityList?.length > 0 ? (
														<>
															<option>Select City</option>
															{filteredCityList.map((city: any) => (
																<option key={city.id} value={city.id}>
																	{city.name}
																</option>
															))}
														</>
													) : (
														<option>Select City</option>
													)}
												</Field>
											</RBFORM.Group>
										</Grid>


										<Grid size={{ xs: 12, md: 6 }}>
											<RBFORM.Group>
												<RBFORM.Label className="label">Postal Code</RBFORM.Label>
												<Field
													name="postalcode"
													type="text"
													placeholder="Enter Postal Code"
													component={formikTextField}
													className="inputC"
												/>
											</RBFORM.Group>
										</Grid>


										<Grid size={{ xs: 12, md: 6 }}>
											<RBFORM.Group>
												<RBFORM.Label className="label">Phone Number</RBFORM.Label>
												<Field
													name="number"
													type="text"
													placeholder="Enter Phone Number"
													component={formikTextField}
													className="inputC"
												/>
											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, md: 6 }}>
											<RBFORM.Group>
												<RBFORM.Label className="label">Mobile Number</RBFORM.Label>
												<PhoneInput
													specialLabel=""
													dropdownClass="user-phone-input-dropdown"
													containerClass="user-phone-input-container"
													inputClass={`${errors.mobile ? "errors" : ""} modalForm-input user-phone-input`}
													inputStyle={{
														boxShadow: 'none',
														color: "#A5A8A9",
														border: "1px solid #313838 !important",
														width: "100%",
														height: "40px",
														backgroundColor: "#192529",
													}}
													placeholder="Enter Mobile Number"
													value={values.mobile}
													onChange={(number) => setFieldValue("mobile", number)}
												/>
											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, md: 12 }}>
											<RBFORM.Group>
												<RBFORM.Label className="label">Timezone</RBFORM.Label>
												<Field
													name="timezone"
													as="select"
													className="inputC custDropdown"
													onChange={(e: any) => handleTimeZoneChange(e, setFieldValue)}
													style={{ cursor: "pointer" }}
												>
													<option disabled>Select</option>
													{timezoneList.map((tz) => (
														<option key={tz.value} value={tz.value}>
															{tz.label}
														</option>
													))}

												</Field>
											</RBFORM.Group>
										</Grid>
										<div style={{ display: "flex", alignItems: "center" }}>
											<span>
												<img src={noteIcon} style={{ width: "20px", height: "20px" }} />
											</span>
											<span
												className="label"
												style={{ marginLeft: "8px", marginTop: "1.5px", fontSize: "14px", fontWeight: "400" }}
											>
												Note: If the timezone is not set at the site level, it will default to the customer’s timezone. If the customer’s timezone is also not set, UTC time will be set as default
											</span>
										</div>

									</Grid>

									<Field
										name="enterpriseid"
										type="hidden"
										placeholder="Enter Phone Number"
										component={formikTextField}
										className="inputC"
										style={{ display: "none" }}
										value={customerEnterpriseId}
									/>

									{/* <input type="text" name="enterpriseid" value={customerEnterpriseId} /> */}
									{/* {JSON.stringify(values, null, 2)} */}



									<Box sx={{ display: "flex", borderTop: "1px solid #5A5F60", paddingTop: '20px', justifyContent: "flex-end", gap: 2 }}>
										<Button type="button" onClick={handleAddSiteModalClose} variant="outlined" className="hoverBtn"
											sx={{ color: '#0699CE', textTransform: 'capitalize', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}
										>
											Cancel
										</Button>
										<Button
											type="submit"
											variant="contained"
											disabled={isSubmitting}
											sx={{
												color: '#1F2F34', height: '41px', lineHeight: '41px',
												borderColor: '#0B4A62', background: '#17B2EB',
												borderRadius: '25px', fontSize: '14px',
												fontWidth: '500',
												textTransform: 'capitalize',
											}}
										>
											Save Changes
										</Button>
									</Box>
								</Form>

								{/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
								</>
							)}
						
							
						</Formik>
					</Box>
				</Modal>
			}


			{editCustomerAdminModalOpen &&
				<Modal
					open={editCustomerAdminModalOpen}
					onClose={handleEditCustomerAdminModalClose}
					className="AddFeatureM"
				>
					<Box sx={{
						maxWidth: '736px',
						width: '100%',
						margin: '64px auto 0',
						padding: '24px',
						borderRadius: '30px',
						borderColor: '#5A5F60 !important',
						border: '1px solid',
					}}
					>
						<Typography variant="h6" component="h2" gutterBottom
							sx={{
								fontSize: '20px',
								color: '#E2E3E3',
								borderBottom: '1px solid #5A5F60',
								paddingBottom: '10px',
								marginBottom: '30px',
							}}
						>
							Edit Customer Admin - {editCustomerAdminName}
							<span onClick={handleEditCustomerAdminModalClose}><CloseIcon style={{ float: "right", cursor: "pointer" }}></CloseIcon></span>
						</Typography>

						<Formik
							initialValues={customerAdminInitialValues}
							enableReinitialize={true} // Enable reinitialization
							validationSchema={object({
								adminname: string().trim().required("Customer name is required!"),
								adminemail: string().email().required("Email ID is required!"),
								adminmobile: string().trim().optional(),
							})}
							onSubmit={async (values, { setSubmitting }) => {

								let temp_values = { ...values };

								if (temp_values.adminmobile != "" && !temp_values.adminmobile.includes("+")) {
									temp_values = { ...temp_values, adminmobile: `+${temp_values.adminmobile}` }
								}

								if (typeof (temp_values.adminprofileimage) == "string" && temp_values.adminprofileimage != "") {
									const image_file = await convertBase64ToFormData(customerAdminLogoFile, customerAdminImageType);
									temp_values.adminprofileimage = image_file;
								}

								const resp = await postMethodFormData(`customer/admin/${editCustomerAdminEnterpriseId}/${editCustomerAdminUserId}`, temp_values);
								if (resp?.status === 200) {
									if(!isSearching) fetchCustomerList();
									else handleSearch(searchText);
									setToast("Customer admin details updated successfully!", "success");
									setEditCustomerAdminModalOpen(false);
								} else {
									setToast(resp?.data?.message, "error");
								}
							}}
						>
							{({ values, isSubmitting, setFieldValue, errors, touched, setFieldTouched }) => (
								<Form>
									<Grid container spacing={2} className="customer_popup" style={{ paddingBottom: "30px" }}>

										<Grid size={{ xs: 12, sm: 12 }}>
											<RBFORM.Group>
												<Typography variant="subtitle1"
													sx={{
														color: '#B4B7B8',
														fontSize: '14px',
													}}
												> Customer Admin Name<span style={{ color: "red" }}>*</span></Typography>
												<Field
													name="adminname"
													as="input"
													type="text"
													component={formikTextField}
													className="inputC"
													placeholder="Enter Customer Admin Name"
												/>
											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, sm: 6 }}>
											<RBFORM.Group>
												<Typography variant="subtitle1"
													sx={{
														color: '#B4B7B8',
														fontSize: '14px',
													}}
												> Email ID<span style={{ color: "red" }}>*</span></Typography>
												<Field
													name="adminemail"
													type="text"
													component={formikTextField}
													className="inputC"
													placeholder="Enter Email ID"
												/>
											</RBFORM.Group>
										</Grid>

										<Grid size={{ xs: 12, md: 6 }}>
											<RBFORM.Group>
												<RBFORM.Label className="label">Mobile Number</RBFORM.Label>
												<PhoneInput
													country={'us'}
													specialLabel=""
													dropdownClass="user-phone-input-dropdown"
													containerClass="user-phone-input-container"
													inputClass={`${errors.adminmobile ? "errors" : ""} modalForm-input user-phone-input`}
													inputStyle={{
														boxShadow: 'none',
														color: "#A5A8A9",
														border: "1px solid #313838 !important",
														width: "100%",
														height: "40px",
														backgroundColor: "#192529",
													}}
													value={values.adminmobile}
													onChange={(number) => setFieldValue("adminmobile", number)}
												/>
											</RBFORM.Group>
										</Grid>


										<Grid size={{ xs: 12, md: 12 }}>
											<RBFORM.Group className="UploadFld">
												<RBFORM.Label className="label">Upload Admin Photo</RBFORM.Label>
												<input
													name="adminprofileimage"
													type="file"
													accept=".jpg,.jpeg,.png,.gif"
													className="inputC UploadIn"
													onChange={(e: any) => {
														handleImageChange(e, "adminprofileimage", setFieldValue, setFieldTouched);
													}}
													id='file'
													ref={customerInputFile}
													style={{ display: 'none' }}
												/>

												<Box
													className="UploadIcon1"
													style={{ width: '100%', height: '120px', border: '1px dashed #5A5F60', borderRadius: '8px', background: '#192529', textAlign: 'center', verticalAlign: 'middle' }}>
													{customerAdminLogoFile &&
														<>
															<div className="" style={{ display: "flex", height: "100%", position: "relative" }}>
																<img src={customerAdminLogoFile} style={{ height: '100%', width: 'auto', float: 'left' }} />
																<img src={DeleteIcon} style={{ width: "18px", height: "18px", position: "relative", top: "5px", left: "-20px", cursor: "pointer" }} onClick={(e: any) => removePhoto("adminprofileimage", setFieldValue)} />
															</div>
														</>
													}
													<Box className="UploadIcon" style={{ top: "80px", cursor: 'pointer' }} onClick={() => handleInputFile('customer')}>
														<img src={UploadIn} alt="" width={24} height={24} /> Upload Photo
													</Box>
												</Box>
												{adminProfileImageError && touched.adminprofileimage && (
													<div style={{ color: "#f44336", fontSize: "0.75rem" }}>{adminProfileImageError}</div>
												)}
											</RBFORM.Group>
										</Grid>
									</Grid>

									<input type="hidden" name="enterpriseid" />
									{/* {JSON.stringify(values, null, 2)} */}

									<Box sx={{ display: "flex", borderTop: "1px solid #5A5F60", paddingTop: '20px', justifyContent: "flex-end", gap: 2 }}>
										<Button type="button" onClick={handleEditCustomerAdminModalClose} variant="outlined"
											sx={{ color: '#0699CE', textTransform: 'capitalize', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}
										>
											Cancel
										</Button>
										<Button
											type="submit"
											variant="contained"
											disabled={isSubmitting}
											sx={{
												color: '#1F2F34', height: '41px', lineHeight: '41px',
												borderColor: '#0B4A62', background: '#17B2EB',
												borderRadius: '25px', fontSize: '14px',
												fontWidth: '500',
												textTransform: 'capitalize',
											}}
										>
											Save Changes
										</Button>
									</Box>
								</Form>
							)}
						</Formik>
					</Box>
				</Modal>
			}

			{/* Added for registration status  */}
			{checkRegistraionStatusModalOpen &&
				<Modal
					open={checkRegistraionStatusModalOpen}
					onClose={handleCheckRegStatusModalClose}
					className="AddFeatureM"
				>
					<Box sx={{
						maxWidth: '600px',
						width: '100%',
						margin: '64px auto 0',
						padding: '24px',
						borderRadius: '30px',
						borderColor: '#5A5F60 !important',
						border: '1px solid',
						marginTop: '230px',
						height: "300px"

					}}
					>
						<Typography variant="h6" component="h2" gutterBottom
							sx={{
								fontSize: '20px',
								color: '#E2E3E3',
								borderBottom: '1px solid #5A5F60',
								paddingBottom: '10px',
								marginBottom: '30px',
							}}
						>
							Check Registration Status
							<span onClick={handleCheckRegStatusModalClose}><CloseIcon style={{ float: "right", cursor: "pointer" }}></CloseIcon></span>
						</Typography>

						<Grid size={{ xs: 12, sm: 6 }} sx={{ height: "80px" }} >
							<Typography
								variant="h6"
								component="h2"
								gutterBottom
								sx={{
									fontSize: "20px",
									color: "#E2E3E3",
									// borderBottom: "1px solid #5A5F60",
									paddingBottom: "10px",
									// marginBottom: "20px",
									display: "flex",
									alignItems: "center",
									gridGap: '8px',
								}}
							>
								<img src={sitesGreyIcon} alt="" width={20} height={20} />
								{siteInitialValues?.name}
							</Typography>
							<RBFORM.Group>
								<Typography variant="subtitle1"
									sx={{
										color: '#B4B7B8',
										fontSize: '14px',
									}}
								> Unique Hardware ID</Typography>
								<TextField
									fullWidth
									variant="outlined"
									value={siteInitialValues.uniqueid}
									placeholder="Enter Unique Hardware ID"
									className="inputC"
								// disabled
								/>
							</RBFORM.Group>
						</Grid>
						{/* </Grid> */}

						<Box sx={{ display: "flex", borderTop: "1px solid #5A5F60", paddingTop: '50px', justifyContent: "flex-end", gap: 2 }}>
							<Button type="button" onClick={handleCheckRegStatusModalClose} variant="outlined" className="hoverBtn"
								sx={{ color: '#0699CE', textTransform: 'capitalize', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}
							>
								Cancel
							</Button>

							<Button type="button" onClick={handleGetRegStatusModalOpen} variant="outlined" className="hoverBtn"
								sx={{
									color: '#1F2F34', height: '41px', lineHeight: '41px',
									borderColor: '#0B4A62', background: '#17B2EB',
									borderRadius: '25px', fontSize: '14px',
									fontWidth: '500',
									textTransform: 'capitalize',
								}}
							>
								Check Status
							</Button>
						</Box>
					</Box>
				</Modal>
			}

			{/* Added to get status */}
			{getRegistraionStatusModalOpen && (
				<Modal
					open={getRegistraionStatusModalOpen}
					onClose={handleGetRegStatusModalClose}
					className="AddFeatureM"
				>
					<Box
						sx={{
							maxWidth: "736px",
							width: "100%",
							margin: "64px auto 0",
							padding: "24px",
							borderRadius: "30px",
							border: "1px solid #5A5F60",
							backgroundColor: "#03171f",
							maxHeight: "80vh",
							overflow: "hidden",
							display: "flex",
							flexDirection: "column",
						}}
					>
						{/* Header */}
						<Typography
							variant="h6"
							component="h2"
							gutterBottom
							sx={{
								fontSize: "20px",
								color: "#E2E3E3",
								borderBottom: "1px solid #5A5F60",
								paddingBottom: "10px",
								marginBottom: "20px",
							}}
						>
							Check Registration Status
							<span onClick={handleGetRegStatusModalClose}>
								<CloseIcon style={{ float: "right", cursor: "pointer" }} />
							</span>
						</Typography>

						{/* Fixed Form Section */}
						<Box sx={{ flexShrink: 0 }}>

							<Grid size={{ xs: 12, sm: 6 }}>
									<Typography
										variant="h6"
										component="h2"
										gutterBottom
										sx={{
											fontSize: "20px",
											color: "#E2E3E3",
											// borderBottom: "1px solid #5A5F60",
											paddingBottom: "10px",
											marginBottom: "20px",
											display: "flex",       
    										alignItems: "center",
											gridGap: '8px',
										}}
									>
										<img src={sitesGreyIcon} alt="" width={20} height={20} />
										{siteInitialValues?.name}

									</Typography>
	
								<Typography variant="subtitle1" sx={{ color: "#E2E3E3", fontSize: "14px" }}>
									Unique Hardware ID
								</Typography>
								<TextField
									fullWidth
									variant="outlined"
									value={siteInitialValues.uniqueid}
									placeholder="Enter Unique Hardware ID"
									className="inputC"
								/>
							</Grid>
							<Grid container spacing={2}>
								
								<Grid size={{ xs: 12, sm: 6 }}>
									<Typography variant="subtitle1" sx={{ color: "#E2E3E3", fontSize: "14px" }}>
										Version Number
									</Typography>
									<TextField
										fullWidth
										variant="outlined"
										// value={siteInitialValues?.dockerTagVersion}
										value={version}
										// placeholder="No Data"
										className="inputC"
									/>
								</Grid>

								
								<Grid size={{ xs: 12, sm: 6 }}>
									<Typography variant="subtitle1" sx={{ color: "#E2E3E3", fontSize: "14px" }}>
										LAN IP Address
									</Typography>
									<Select
										fullWidth
										variant="outlined"
										value={siteInitialValues?.ipList?.[0]} 
										className="inputC"
										sx={{
											"& .MuiSelect-select": {
												padding: "6px 10px",
												color: "#A5A8A9",  
											},
											
											minHeight: "40px", 
											fontSize: "14px", 
										}}
									>
										{siteInitialValues?.ipList?.map((ip: string, index: number) => (
											<MenuItem key={index} value={ip}>
												{ip}
											</MenuItem>
										))}
									</Select>
								</Grid>
							</Grid>

							<Typography
								variant="h6"
								component="h2"
								sx={{
									marginTop: "10px",
									fontSize: "16px",
									color: "#E2E3E3",
									// borderTop: "1px solid #5A5F60",
									paddingTop: "10px",
									// borderBottom: "1px solid #5A5F60",
									paddingBottom: "10px",
									marginBottom: "10px",
								}}
							>
								Registration Request Details
							</Typography>
						</Box>

						{/* Scrollable Table Section */}
						<Box sx={{
							flexGrow: 1, overflowY: "scroll", border: "1px solid #5A5F60", borderRadius: "10px", padding: "10px", scrollbarWidth: "none",
							msOverflowStyle: "none",
						}}>
							<TableContainer component={Paper} sx={{ backgroundColor: "#1D292E" }}>
								<Table sx={{ border: "1px solid #313838" }}>
									<TableHead>
										<TableRow style={{ borderBottom: "2px solid #313838" }}>
											<TableCell style={{ color: "#E2E3E3", borderColor: "#313838" }}>Status</TableCell>
											<TableCell style={{ color: "#E2E3E3", borderColor: "#313838" }}>Date & Time</TableCell>
											<TableCell style={{ color: "#E2E3E3", borderColor: "#313838" }}>Message</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{Array.isArray(siteLogData) && siteLogData?.length > 0 ? (
											siteLogData?.map((log, index) => (
												<TableRow key={index} sx={{ borderBottom: "1px solid #313838", cursor: "pointer" }}>
													<TableCell sx={{ color: "#E2E3E3", borderColor: "#313838" }}>{log.status || "-"}</TableCell>
													<TableCell sx={{ color: "#E2E3E3", borderColor: "#313838" }}>
														{log.time ? new Date(log.time).toLocaleString() : "-"}
													</TableCell>
													<TableCell sx={{ color: "#E2E3E3", borderColor: "#313838" }}>{log.detailMessage || "-"}</TableCell>
												</TableRow>
											))
										) : (
											<TableRow>
												<TableCell colSpan={3} sx={{ textAlign: "center", color: "#E2E3E3", padding: "20px" }}>
													Click <strong>Refresh</strong> to get data
												</TableCell>
											</TableRow>
										)}
									</TableBody>
								</Table>
							</TableContainer>
						</Box>

						{/* Footer Buttons */}
						<Box sx={{ display: "flex", borderTop: "1px solid #5A5F60", paddingTop: "20px", justifyContent: "flex-end", gap: 2 }}>
							<Button
								type="button"
								onClick={handleGetRegStatusModalClose}
								variant="outlined"
								className="hoverBtn"
								sx={{
									color: "#0699CE",
									textTransform: "capitalize",
									height: "41px",
									lineHeight: "41px",
									borderColor: "#0B4A62",
									borderRadius: "25px",
									fontSize: "14px",
									fontWeight: "500",
								}}
							>
								Cancel
							</Button>

							<Button
								type="button"
								onClick={handleRefreshSiteRegistrationStatus}
								variant="outlined"
								className="hoverBtn"
								sx={{
									color: "#1F2F34",
									height: "41px",
									lineHeight: "41px",
									borderColor: "#0B4A62",
									background: "#17B2EB",
									borderRadius: "25px",
									fontSize: "14px",
									fontWeight: "500",
									textTransform: "capitalize",
								}}
							>
								Refresh
							</Button>
						</Box>
					</Box>
				</Modal>
			)}

			{suspendModalOpen &&
				<AlertDialogs
					open={suspendModalOpen}
					setOpen={setSuspendModalOpen}
					getConfirmResponse={getConfirmResponse}
					title={`${suspendCustomerAction === "Suspend" ? "Suspend Customer" : "Activate Customer"}`}
					message={suspendCustomerAction === "Suspend"
						? "All the sites / devices associated with this customer and the related licenses will be deleted.<br/>Are you sure you want to suspend this customer?"
						: "The customer will be activated.<br/>Are you sure you want to activate this customer?"}

					button1="Cancel"
					button2={suspendCustomerAction}
				/>
			}

			{suspendSiteModalOpen &&
				<AlertDialogs
					open={suspendSiteModalOpen}
					setOpen={setSuspendSiteModalOpen}
					getConfirmResponse={handleSiteSuspendActivateDelete}
					title={`${suspendSiteAction === "Suspend" ? "Suspend Site" : "Activate Site"}`}
					message={`The sites will be ${suspendSiteAction === "Suspend" ? "suspended" : "activated"}.<br/>Are you sure you want to ${suspendSiteAction === "Suspend" ? "suspend" : "activate"} this site?`}
					button1="Cancel"
					button2={suspendSiteAction}
				/>
			}


			{deleteSiteModalOpen &&
				<AlertDialogs
					open={deleteSiteModalOpen}
					setOpen={setDeleteSiteModalOpen}
					getConfirmResponse={handleSiteSuspendActivateDelete}
					title="Delete Site"
					message="The sites will be deleted.<br/>Are you sure you want to delete this site?"
					button1="Cancel"
					button2="Delete"
				/>
			}

			{deleteModalOpen &&
				<AlertDialogs
					open={deleteModalOpen}
					setOpen={setDeleteModalOpen}
					getConfirmResponse={getConfirmResponse}
					title="Delete Customer"
					message="All the sites / devices associated with this customer and the related licenses will be deleted.<br/>Are you sure you want to delete this customer?"
					button1="Cancel"
					button2="Delete"
				/>
			}

			{updateModalOpen &&
				<AlertDialogs
					open={updateModalOpen}
					setOpen={setUpdateModalOpen}
					getConfirmResponse={getUpdateResponse}
					title={updateSiteAction === "Update" ? "Update Site" : "Rollback Site"}
					message={
						updateSiteAction === "Update"
							? `Current version: ${selectedSiteForUpdate?.currentVersion?.[0]} <br />A newer version, ${selectedSiteForUpdate?.latestVersion?.[0]}, is available.<br /><br />Would you like to update to the latest version?`
							: `Current version: ${selectedSiteForUpdate?.currentVersion?.[0]} <br />Previous version: ${selectedSiteForUpdate?.previousVersion?.[0]} <br /><br />Would you like to roll back to the previous version?`
					}
					button1="Cancel"
					button2={updateSiteAction}
				/>
			}

			{rebootModalOpen &&
				<AlertDialogs
					open={rebootModalOpen}
					setOpen={setRebootModalOpen}
					getConfirmResponse={getRebootResponse}
					title="Reboot Site"
					message="Do you want to reboot the site ?"
					button1="Cancel"
					button2="Reboot"
				/>
			}

			{/* For each customer */}
			{updateCustomerModalOpen &&
				<AlertDialogs
					open={updateCustomerModalOpen}
					setOpen={setUpdateCustomerModalOpen}
					getConfirmResponse={getUpdateCustomerResponse}
					title="Update Site"
					message={
						<Box sx={{maxHeight: 300 }}>
							<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2, maxHeight: 200, overflowY: 'auto'}}>
									<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
									
									<Checkbox
										checked={selectAllForSitesUpdate}
										onChange={(e) => handleSelectAllSitesForUpdate(e.target.checked)}
										icon={
											<Box
												sx={{
													width: 20,
													height: 20,
													border: '2px solid #A5A8A9',
													borderRadius: 1,
												}}
											/>
										}
										checkedIcon={
											<Box
												sx={{
													width: 20,
													height: 20,
													backgroundColor: '#17B2EB',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													borderRadius: 1, 
												}}
											>
												<CheckIcon sx={{ color: 'black !important', fontSize: 16 }} />
											</Box>
										}
									/>
										<Typography id="selectAllSites" sx={{ typographyStyle }}>
											Select All Sites
										</Typography>
									</Box>
								{siteListPerCustomer?.map((site: any) => (
									<Box key={site.siteId} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
										
										<Checkbox
											checked={checkedSitesForUpdate?.includes(site.siteId)}
											onChange={(e) => handleCheckedSiteForUpdate(site.siteId, e.target.checked)}
											icon={
												<Box
													sx={{
														width: 20,
														height: 20,
														border: '2px solid #A5A8A9',
														borderRadius: 1, 
													}}
												/>
											}
											checkedIcon={
												<Box
													sx={{
														width: 20,
														height: 20,
														backgroundColor: '#17B2EB',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														borderRadius: 1, 
													}}
												>
													<CheckIcon sx={{ color: 'black !important', fontSize: 16 }} />
												</Box>
											}
										/>
										<img src={sitesGreyIcon} alt="" width={20} height={20} />
										<Typography id={`site-${site.siteId}`} sx={{typographyStyle}}>
											{site.siteName}
										</Typography>
									</Box>
								))}
								{/* <Typography sx={{ mt: 2 }}>Current version: {selectedSiteForUpdate?.currentVersion?.[0]}</Typography> */}
								<Typography>A newer version, {latestVersion}, is available.</Typography>
								<Typography sx={{ mt: 1 }}>Would you like to update to the latest version?</Typography>
							</Box>
							<Typography sx={{typographyStyle}}>
								Selected sites will be updated and the system will be offline for few minutes.
							</Typography>
							<Typography sx={{typographyStyle, paddingTop: 2}}>Are you sure you want to Update?</Typography>
						</Box>
					}

					button1="Cancel"
					button2="Update"
				/>
			}

			{/* For each site under a customer */}
			{updateEachSiteModalOpen &&
				<AlertDialogs
					open={updateEachSiteModalOpen}
					setOpen={setUpdateEachSiteModalOpen}
					getConfirmResponse={getUpdateCustomerResponse}
					title={updateSiteAction === "Update" ? "Update Site" : "Rollback Site"}
					message={
						<Box sx={{maxHeight: 300 }}>
							<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2, maxHeight: 200, overflowY: 'auto'}}>
									<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
										<img src={sitesGreyIcon} alt="" width={20} height={20} />
										<Typography sx={{typographyStyle}}>
											{checkedSitesNameForUpdate}
										</Typography>
									</Box>
									<Box>
									{/* <Typography>
										{
											updateSiteAction === "Update"
												? `Current version: ${selectedSiteForUpdate?.currentVersion?.[0]} <br />A newer version, ${selectedSiteForUpdate?.latestVersion?.[0]}, is available.<br /><br />Would you like to update to the latest version?`
												: `Current version: ${selectedSiteForUpdate?.currentVersion?.[0]} <br />Previous version: ${selectedSiteForUpdate?.previousVersion?.[0]} <br /><br />Would you like to roll back to the previous version?`
										}
									</Typography> */}
									{updateSiteAction === "Update" ? (
										<>
											<Typography sx={{ mt: 2 }}>Current version: {selectedSiteForUpdate?.currentVersion?.[0]}</Typography>
											<Typography>A newer version, {selectedSiteForUpdate?.latestVersion?.[0]}, is available.</Typography>
											<Typography sx={{ mt: 1 }}>Would you like to update to the latest version?</Typography>
										</>
									) : (
										<>
											<Typography sx={{ mt: 2 }}>Current version: {selectedSiteForUpdate?.currentVersion?.[0]}</Typography>
											<Typography>Previous version: {selectedSiteForUpdate?.previousVersion?.[0]}</Typography>
											<Typography sx={{ mt: 1 }}>Would you like to roll back to the previous version?</Typography>
										</>
									)}

									</Box>
							</Box>
							{updateSiteAction === "Update" ? (
								<>
									<Typography sx={{ typographyStyle }}>
										Selected site will be updated and the system will be offline for few minutes.
									</Typography>
								</>
							) : (
								<>
									<Typography sx={{ typographyStyle }}>
										Selected site will be rolled back and the system will be offline for few minutes.
									</Typography></>
							)}
							{/* <Typography sx={{typographyStyle, paddingTop: 2}}>Are you sure you want to Update?</Typography> */}
						</Box>
					}

					button1="Cancel"
					button2={updateSiteAction}
				/>
			}
		</>
	);
};

export default CustomerOverview;